(() => {
  const init = () => {
    customLogicBehavior.init();
  };

  const initWhenReady = () => {
    if (!window.CPB || !document.querySelector("#product-builder")) return;
    init();
  };

  document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", init);
  document.addEventListener("DOMContentLoaded", initWhenReady);
  window.addEventListener("load", initWhenReady);

  [300, 1000, 2500].forEach(delay => {
    setTimeout(initWhenReady, delay);
  });

  const customLogicBehavior = {
    logicStorage: null,
    api: null,
    mobileStepObserver: null,
    mobileStepObserverTimer: null,
    mobileStepRaf: null,
    mobileStepSettleTimers: [],
    mobileStepScrollRestoreTimers: [],
    mobileStepScrollPatchTimer: null,
    mobileStepScrollFunctionsPatched: false,
    mobileStepOriginalScrollTo: null,
    mobileStepOriginalScrollBy: null,
    mobileStepOriginalScrollIntoView: null,
    mobileStepScrollRestoreUntil: 0,
    mobileStepScrollTop: 0,
    isRestoringMobileStepScroll: false,
    mobileScrollPauseUntil: 0,
    mobileOptionTouchUntil: 0,
    mobileScrollPauseTimer: null,
    mobileScrollPauseBound: false,
    mobileStaticLockRaf: null,
    nativeStepPointerAt: 0,
    nativeStepPointerStartX: 0,
    nativeStepPointerStartY: 0,
    nativeStepPointerStartAt: 0,
    nativeStepGestureMoved: false,
    nativeStepSuppressClickUntil: 0,
    nativeStepSyntheticClick: false,
    nativeStepSyntheticUntil: 0,
    layoutLockRaf: null,
    lastLayoutNormalizeAt: 0,
    lastLayoutNormalizeWidth: 0,
    lastCustomPriceKey: "",
    mobileOptionSliderTimers: new WeakMap(),
    recommendationObserver: null,
    recommendationObserverTimer: null,
    desktopPreviewFollowBound: false,
    desktopPreviewFollowRaf: null,
    lifestyleGalleryInteractionUntil: 0,
    afterpayOriginalParent: null,
    afterpayOriginalNextSibling: null,
    afterpayMovedElement: null,
    mobileActionsHolder: null,
    actionsOriginalParent: null,
    actionsOriginalNextSibling: null,
    mobilePanelOriginalPositions: new WeakMap(),
    hasRestoredInitialMobileScroll: false,
    isMobileStepMoving: false,
    isInitializing: false,
    hasInitialized: false,

    isCpbProductPage() {
      const context = document.querySelector("#cpb-product-context");

      if (!context) {
        return Boolean(document.querySelector("#product-builder"));
      }

      return context.dataset.isCpbProduct === "true";
    },

    isCpbReady() {
      if (
        !window.CPB ||
        !CPB.getStore ||
        !CPB.FrontendApi ||
        !document.querySelector("#product-builder")
      ) {
        return false;
      }

      if (!this.isCpbProductPage()) {
        return false;
      }

      const panels = CPB.getStore().getState()?.Product?.panels;
      return Array.isArray(panels) && panels.length > 0;
    },

    normalizeCpbProductLayout(force = false) {
      const root = document.querySelector("#product-builder");
      if (!root || !this.isCpbProductPage()) return;

      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      const now = Date.now();

      if (
        !force &&
        root.dataset.cpbProductLayout === "normalized" &&
        viewportWidth === this.lastLayoutNormalizeWidth
      ) {
        return;
      }

      this.lastLayoutNormalizeAt = now;
      this.lastLayoutNormalizeWidth = viewportWidth;

      root.dataset.cpbProductLayout = "normalized";
      document.body.classList.add("cpb-product-layout-normalized");

      const layout = root.querySelector(".cpb-layout");
      layout?.classList.add("cpb-custom-normalized-layout");

      const layoutClasses = [
        "cpb-use-sticky",
        "cpb-sticky",
        "cpb-is-sticky",
        "cpb-layout-sticky",
        "cpb-shift-60",
        "cpb-shifted"
      ];

      const stickyElements = Array.from(root.querySelectorAll(
        '[style*="position"], [style*="top"], [style*="transform"], [style*="scale"]'
      )).filter(element => {
        if (element.closest(".cpb-panels-tabs, .cpb-panels-container")) {
          return false;
        }

        const styles = window.getComputedStyle(element);

        return (
          styles.position === "fixed" ||
          styles.position === "sticky" ||
          styles.transform !== "none" ||
          element.style.scale
        );
      });

      const normalizedElements = [
        ...root.querySelectorAll(`
        .cpb-layout,
        .cpb-preview,
        .cpb-preview-aside,
        .cpb-preview-container,
        .cpb-preview-wrapper,
        .cpb-preview-sticky,
        .cpb-product-preview,
        .cpb-product-image,
        [class*="sticky"],
        [class*="Sticky"],
        [class*="shift"],
        [class*="Shift"]
        `),
        ...stickyElements
      ];

      const themeProductMediaElements = Array.from(document.querySelectorAll(`
        .product-single__sticky,
        .product-single__media-group,
        .product-single__photos,
        .product-single__photo-wrapper,
        .product-single__photo,
        .product__photos,
        .product__main-photos,
        .product__media,
        .product__media-wrapper,
        .product__photo-container,
        .product__photo,
        .product-image-main,
        .product__thumbs,
        .product-slideshow,
        .product-main-slide,
        .product-gallery,
        .product-gallery__media,
        .product-media-container,
        .product__media-list,
        [data-product-images],
        [data-product-media],
        [data-product-media-wrapper],
        [data-product-single-media-wrapper],
        [data-product-image-main],
        [data-product-photo],
        [data-product-photos]
      `)).filter(element => {
        if (element.closest("#product-builder")) return false;

        const nativeProductSection = element.closest(".product-section.cpb-basic-product");
        return !nativeProductSection || nativeProductSection.querySelector(
          "#product-builder, .cpb-root, .cpb-product-builder, .cpb-theme-provider, .cpb-layout"
        );
      });

      const mobileMediaStage = window.innerWidth <= 768
        ? Array.from(document.querySelectorAll(`
          .product-single__media-group,
          .product-single__photos,
          .product__photos,
          .product__main-photos,
          .product__media-wrapper,
          .product-slideshow,
          .product-gallery,
          [data-product-images],
          [data-product-media-wrapper],
          [data-product-single-media-wrapper],
          [data-product-photos],
          .product-single__sticky
        `)).find(element => {
          return (
            !element.closest("#product-builder") &&
            (
              !element.closest(".product-section.cpb-basic-product") ||
              element.closest(".product-section.cpb-basic-product").querySelector(
                "#product-builder, .cpb-root, .cpb-product-builder, .cpb-theme-provider, .cpb-layout"
              )
            ) &&
            element.querySelector("img, picture, model-viewer, canvas")
          );
        })
        : null;

      const themeHeaderElements = Array.from(document.querySelectorAll(`
        #shopify-section-header,
        .shopify-section-header,
        .shopify-section-group-header-group,
        .header-wrapper,
        .header-section,
        .header-sticky-wrapper,
        .site-header,
        .site-header-wrapper,
        .announcement-bar,
        .announcement-bar-section,
        sticky-header,
        header[role="banner"],
        [data-section-type*="header"],
        [class*="sticky-header"],
        [class*="StickyHeader"],
        [class*="header-sticky"],
        [class*="HeaderSticky"]
      `)).filter(element => !element.closest("#product-builder"));

      new Set(normalizedElements).forEach(element => {
        const isImageStageElement = element.matches(".cpb-product-preview, .cpb-product-image");

        layoutClasses.forEach(className => element.classList.remove(className));
        element.style.removeProperty("transform");
        element.style.removeProperty("scale");

        if (window.innerWidth <= 768) {
          element.style.setProperty("position", "relative", "important");
          element.style.setProperty("top", "auto", "important");
          element.style.setProperty("right", "auto", "important");
          element.style.setProperty("bottom", "auto", "important");
          element.style.setProperty("left", "auto", "important");
          element.style.setProperty(
            "height",
            isImageStageElement ? "var(--cpb-mobile-media-stage-height, 360px)" : "auto",
            "important"
          );
          element.style.setProperty(
            "min-height",
            isImageStageElement ? "var(--cpb-mobile-media-stage-height, 360px)" : "0",
            "important"
          );
          element.style.setProperty(
            "max-height",
            isImageStageElement ? "var(--cpb-mobile-media-stage-height, 360px)" : "none",
            "important"
          );
          element.style.setProperty("transform", "none", "important");
          element.style.setProperty("scale", "1", "important");
          element.style.setProperty("translate", "none", "important");
          element.style.removeProperty("width");
          element.style.removeProperty("max-width");
        }
      });

      new Set(themeProductMediaElements).forEach(element => {
        layoutClasses.forEach(className => element.classList.remove(className));
        element.classList.add("cpb-theme-product-media-normalized");
        element.classList.toggle("cpb-mobile-media-stage", element === mobileMediaStage);
        element.style.removeProperty("transform");
        element.style.removeProperty("scale");

        if (window.innerWidth <= 768) {
          element.style.setProperty("position", "static", "important");
          element.style.setProperty("top", "auto", "important");
          element.style.setProperty("right", "auto", "important");
          element.style.setProperty("bottom", "auto", "important");
          element.style.setProperty("left", "auto", "important");
          element.style.setProperty("transform", "none", "important");
          element.style.setProperty("scale", "1", "important");
          element.style.setProperty("translate", "none", "important");
          element.style.removeProperty("width");
          element.style.removeProperty("max-width");
          element.style.removeProperty("height");
          element.style.removeProperty("max-height");
        }
      });

      new Set(themeHeaderElements).forEach(element => {
        element.classList.add("cpb-theme-header-normalized");
        layoutClasses.forEach(className => element.classList.remove(className));

        element.style.setProperty(
          "position",
          window.innerWidth > 768 ? "relative" : "static",
          "important"
        );
        element.style.setProperty("top", "auto", "important");
        element.style.setProperty("right", "auto", "important");
        element.style.setProperty("bottom", "auto", "important");
        element.style.setProperty("left", "auto", "important");
        element.style.setProperty("transform", "none", "important");
        element.style.setProperty("scale", "1", "important");
        element.style.setProperty("translate", "none", "important");
        element.style.setProperty(
          "z-index",
          window.innerWidth > 768 ? "2147482000" : "auto",
          "important"
        );
        element.style.setProperty("overflow", "visible", "important");
      });

      this.lockMobileStaticBuilderLayout();
    },

    queueCpbLayoutLock() {
      if (this.layoutLockRaf) return;

      this.layoutLockRaf = requestAnimationFrame(() => {
        this.layoutLockRaf = null;
        this.normalizeCpbProductLayout();
      });
    },

    lockMobileStaticBuilderLayout() {
      const root = document.querySelector("#product-builder");
      if (!root || window.innerWidth > 768) return;

      root.classList.add("cpb-mobile-static-layout");
      document.body.classList.add("cpb-mobile-static-layout-active");

      const staticElements = root.querySelectorAll(`
        .cpb-layout,
        .cpb-preview,
        .cpb-preview-aside,
        .cpb-preview-container,
        .cpb-preview-wrapper,
        .cpb-preview-sticky,
        .cpb-panels-tabs,
        .cpb-panels-container
      `);

      staticElements.forEach(element => {
        element.style.setProperty("position", "static", "important");
        element.style.setProperty("top", "auto", "important");
        element.style.setProperty("right", "auto", "important");
        element.style.setProperty("bottom", "auto", "important");
        element.style.setProperty("left", "auto", "important");
        element.style.setProperty("height", "auto", "important");
        element.style.setProperty("min-height", "0", "important");
        element.style.setProperty("max-height", "none", "important");
        element.style.setProperty("overflow", "visible", "important");
        element.style.setProperty("visibility", "visible", "important");
        element.style.setProperty("opacity", "1", "important");
        element.style.setProperty("transform", "none", "important");
        element.style.setProperty("scale", "1", "important");
        element.style.setProperty("translate", "none", "important");
      });

      root.querySelectorAll(".cpb-product-preview, .cpb-product-image").forEach(element => {
        element.style.setProperty("position", "relative", "important");
        element.style.setProperty("display", "flex", "important");
        element.style.setProperty("align-items", "center", "important");
        element.style.setProperty("justify-content", "center", "important");
        element.style.setProperty("width", "calc(100% - 24px)", "important");
        element.style.setProperty("max-width", "calc(100% - 24px)", "important");
        element.style.setProperty("flex", "0 0 auto", "important");
        element.style.setProperty("flex-shrink", "0", "important");
        element.style.setProperty("height", "var(--cpb-mobile-media-stage-height, 360px)", "important");
        element.style.setProperty("min-height", "var(--cpb-mobile-media-stage-height, 360px)", "important");
        element.style.setProperty("max-height", "var(--cpb-mobile-media-stage-height, 360px)", "important");
        element.style.setProperty("margin", "10px auto 8px", "important");
        element.style.setProperty("padding", "10px", "important");
        element.style.setProperty("overflow", "hidden", "important");
        element.style.setProperty("visibility", "visible", "important");
        element.style.setProperty("opacity", "1", "important");
        element.style.setProperty("transform", "none", "important");
        element.style.setProperty("scale", "1", "important");
        element.style.setProperty("translate", "none", "important");
      });

      this.syncNativeActivePanel();

      root.querySelectorAll(`
        .cpb-panels-container > .cpb-force-visible-panel,
        .cpb-panels-container .cpb-force-visible-panel,
        .cpb-panels-container .react-tabs__tab-panel--selected,
        .cpb-panels-container [role="tabpanel"][aria-hidden="false"]
      `).forEach(panel => {
        panel.style.setProperty("display", "flow-root", "important");
        panel.style.setProperty("position", "static", "important");
        panel.style.setProperty("height", "auto", "important");
        panel.style.setProperty("min-height", "0", "important");
        panel.style.setProperty("max-height", "none", "important");
        panel.style.setProperty("overflow", "visible", "important");
        panel.style.setProperty("visibility", "visible", "important");
        panel.style.setProperty("opacity", "1", "important");
        panel.style.setProperty("transform", "none", "important");
      });
    },

    queueMobileStaticBuilderLayoutLock() {
      if (window.innerWidth > 768 || this.mobileStaticLockRaf) return;

      this.mobileStaticLockRaf = requestAnimationFrame(() => {
        this.mobileStaticLockRaf = null;
        this.lockMobileStaticBuilderLayout();
      });
    },

    initLogicStorage() {
      const logicInfo = {};

      CPB.getStore().getState().Product.panels.forEach(panel => {
        panel.categories.forEach(category => {
          category.options.forEach(option => {
            if (option.logic.rules.length === 0) return;

            if (!logicInfo[panel.id]) logicInfo[panel.id] = {};
            if (!logicInfo[panel.id][category.id]) logicInfo[panel.id][category.id] = {};

            logicInfo[panel.id][category.id][option.id] = {
              logic: window.structuredClone(option.logic)
            };

            option.logic.rules = [];
          });
        });
      });

      this.logicStorage = logicInfo;
    },

    async initApi() {
      const API = await CPB.FrontendApi();
      this.api = new API();
    },

    initStyle() {
      if (document.querySelector("#cpb-custom-logic-style")) return;

      const styleElem = document.createElement("style");
      styleElem.id = "cpb-custom-logic-style";
      styleElem.textContent = `
        #product-builder [data-category-id] [data-option-id].cpbc-logic-false,
        #product-builder [data-category-id].cpbc-logic-false {
          opacity: 0.25 !important;
          pointer-events: none !important;
        }
      `;

      document.body.append(styleElem);
    },

    update() {
      if (!this.logicStorage || !this.api) return;

      const panelElem = document.querySelector("[data-panel-id]");
      if (!panelElem) return;

      const panelId = panelElem.getAttribute("data-panel-id");
      const panelLogicInfo = this.logicStorage[panelId];
      if (!panelLogicInfo) return;

      Object.keys(panelLogicInfo).forEach(categoryId => {
        if (panelLogicInfo[categoryId].logic) {
          const categoryElem = document.querySelector(`[data-category-id="${categoryId}"]`);
          if (!categoryElem) return;

          if (this.api.checkLogic(panelLogicInfo[categoryId])) {
            categoryElem.classList.add("cpbc-logic-true");
            categoryElem.classList.remove("cpbc-logic-false");
          } else {
            categoryElem.classList.add("cpbc-logic-false");
            categoryElem.classList.remove("cpbc-logic-true");
          }
        }

        Object.keys(panelLogicInfo[categoryId]).forEach(optionId => {
          if (optionId === "logic") return;

          const optionElem = document.querySelector(
            `[data-category-id="${categoryId}"] [data-option-id="${optionId}"]`
          );

          if (!optionElem) return;

          if (this.api.checkLogic(panelLogicInfo[categoryId][optionId])) {
            optionElem.classList.add("cpbc-logic-true");
            optionElem.classList.remove("cpbc-logic-false");
          } else {
            optionElem.classList.add("cpbc-logic-false");
            optionElem.classList.remove("cpbc-logic-true");
          }
        });
      });
    },

    returnDataToState() {
      const logic = this.logicStorage;
      if (!logic) return;

      const state = CPB.getStore().getState();

      for (const panelId in logic) {
        const panel = state.Product.panels.find(item => item.id == panelId);
        if (!panel) continue;

        for (const categoryId in logic[panelId]) {
          const category = panel.categories.find(item => item.id == categoryId);
          if (!category) continue;

          if (Object.prototype.hasOwnProperty.call(logic[panelId][categoryId], "logic")) {
            category.logic = logic[panelId][categoryId].logic;
          }

          for (const optionId in logic[panelId][categoryId]) {
            if (optionId === "logic") continue;

            const option = category.options.find(item => item.id == optionId);
            if (option) option.logic = logic[panelId][categoryId][optionId].logic;
          }
        }
      }

      this.logicStorage = null;
    },

    addCustomInfo() {
      if (document.querySelector("#product-builder .cpb-custom-info")) return;

      const productDescription = document.querySelector(".cpb-product-description");
      const customInfo = document.createElement("div");

      customInfo.classList.add("cpb-custom-info");
      productDescription?.after(customInfo);

      function waitForElement(selector, callback, timeout = 5000) {
        const existing = document.querySelector(selector);

        if (existing) {
          callback(existing);
          return;
        }

        const observer = new MutationObserver(() => {
          const el = document.querySelector(selector);

          if (el) {
            observer.disconnect();
            callback(el);
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => observer.disconnect(), timeout);
      }

      waitForElement(".stamped-product-reviews-badge", reviews => {
        if (customInfo.querySelector(".stamped-product-reviews-badge")) return;

        const cloneReviews = reviews.cloneNode(true);
        cloneReviews.classList.add("cpb-desktop-custom-reviews");
        cloneReviews.style.order = "1";
        customInfo.append(cloneReviews);

        cloneReviews.addEventListener("click", () => {
          const createReview = document.querySelector(".stamped-summary-actions-newreview");
          if (!createReview) return;

          const offset = -150;
          const top = createReview.getBoundingClientRect().top + window.scrollY + offset;
          window.scrollTo({ top, behavior: "smooth" });
        });

        customLogicBehavior.syncMobileIntro();
        customLogicBehavior.syncDesktopCustomInfo();
      });

      function updateCustomPrice(target) {
        const price = target.querySelector('[data-testid="multycurrency-price"]');
        if (!price) return;

        const existing = document.querySelector(".custom-price");
        const currencySymbol = price.textContent.replace(/[\d\s,.\u00A0]+/g, "");
        const comparePrice = CPB.getStore().getState().App.settings.comparePrice;
        const sourcePrice = CPB.getStore().getState().Product.price;
        const priceKey = [
          customLogicBehavior.cleanMoneyText(price.textContent),
          sourcePrice || "",
          comparePrice?.enabled ? "1" : "0",
          comparePrice?.value || ""
        ].join("|");

        if (existing && customLogicBehavior.lastCustomPriceKey === priceKey) {
          return;
        }

        customLogicBehavior.lastCustomPriceKey = priceKey;

        const priceClone = target.cloneNode(true);

        priceClone.classList.add("custom-price");
        priceClone.style.order = "2";

        const clonedPriceValue = priceClone.querySelector('[data-testid="multycurrency-price"]');
        if (clonedPriceValue) {
          clonedPriceValue.textContent = customLogicBehavior.cleanMoneyText(clonedPriceValue.textContent);
        }

        if (comparePrice.enabled && sourcePrice) {
          const comparedPrice = (comparePrice.value / 100) * sourcePrice;
          const savedAmount = document.createElement("div");

          savedAmount.classList.add("cpb-saved-amount");
          savedAmount.textContent = `Save $${comparedPrice}`;
          priceClone.append(savedAmount);
        }

        if (existing) existing.remove();
        customInfo.append(priceClone);

        customLogicBehavior.syncMobileIntro();
        customLogicBehavior.syncDesktopCustomInfo();
        customLogicBehavior.injectDesktopRecommendationBox(priceClone);
        customLogicBehavior.syncRecommendationBoxes();
        customLogicBehavior.syncDesktopBestForBox();
      }

      const targetNode = document.querySelector(".cpb-product-price");
      if (!targetNode) return;

      const observer = new MutationObserver(mutationsList => {
        for (const mutation of mutationsList) {
          if (mutation.type === "characterData" || mutation.type === "childList") {
            updateCustomPrice(targetNode);
          }
        }
      });

      observer.observe(targetNode, {
        characterData: true,
        childList: true,
        subtree: true
      });

      updateCustomPrice(targetNode);
    },

    cleanMoneyText(value) {
      return (value || "")
        .replace(/\s+/g, " ")
        .replace(/^AUD\s*/i, "")
        .replace(/^AU(?=\$)/i, "")
        .replace(/^A(?=\$)/i, "")
        .trim();
    },

    findAfterpayElement() {
      const selectors = [
        ".cpb-mobile-afterpay-widget",
        'square-placement[data-mpid="funkymonkeybars.myshopify.com"]',
        '[data-mpid="funkymonkeybars.myshopify.com"]',
        "square-placement"
      ];

      return selectors
        .flatMap(selector => Array.from(document.querySelectorAll(selector)))
        .find(element => {
          return (
            element &&
            !element.closest(".cpb-mobile-afterpay-copy") &&
            !element.classList.contains("cpb-mobile-afterpay-copy") &&
            !element.classList.contains("cpb-mobile-afterpay-badge") &&
            !element.classList.contains("cpb-mobile-afterpay-info")
          );
        });
    },

    rememberAfterpayPosition(afterpayElement) {
      if (
        this.afterpayOriginalParent ||
        !afterpayElement ||
        afterpayElement.closest(".cpb-mobile-afterpay")
      ) {
        return;
      }

      this.afterpayOriginalParent = afterpayElement.parentNode;
      this.afterpayOriginalNextSibling = afterpayElement.nextSibling;
    },

    restoreAfterpayElement() {
      const afterpayElement = this.afterpayMovedElement;

      if (!afterpayElement || !this.afterpayOriginalParent) return;

      afterpayElement.classList.remove("cpb-mobile-afterpay-widget");
      afterpayElement.classList.remove("cpb-desktop-afterpay-widget");

      if (
        this.afterpayOriginalNextSibling &&
        this.afterpayOriginalNextSibling.parentNode === this.afterpayOriginalParent
      ) {
        this.afterpayOriginalParent.insertBefore(afterpayElement, this.afterpayOriginalNextSibling);
      } else {
        this.afterpayOriginalParent.append(afterpayElement);
      }

      this.afterpayMovedElement = null;
    },

    styleAfterpayWidget() {
      const afterpayElement = this.afterpayMovedElement || this.findAfterpayElement();
      const shadowRoot = afterpayElement?.shadowRoot;

      if (!shadowRoot) return;

      let style = shadowRoot.querySelector("#cpb-mobile-afterpay-style");

      if (!style) {
        style = document.createElement("style");
        style.id = "cpb-mobile-afterpay-style";
        shadowRoot.append(style);
      }

      style.id = "cpb-mobile-afterpay-style";
      style.textContent = `
        .afterpay-main-text,
        .afterpay-main-text *,
        p,
        span {
          font-size: 10px !important;
          line-height: 1.15 !important;
        }

        .afterpay-main-text {
          max-width: 165px !important;
          white-space: normal !important;
        }

        :host(.cpb-desktop-afterpay-widget) .afterpay-main-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          max-width: 340px !important;
          white-space: nowrap !important;
        }

        :host(.cpb-mobile-afterpay-widget) .afterpay-main-text {
          display: block !important;
          max-width: 165px !important;
          white-space: normal !important;
        }
      `;
    },

    syncMobileIntro() {
      const root = document.querySelector("#product-builder");
      if (!root) return;

      if (window.innerWidth > 768) {
        if (!this.afterpayMovedElement?.closest(".cpb-desktop-custom-afterpay")) {
          this.restoreAfterpayElement();
        }

        root.querySelector(".cpb-mobile-intro")?.remove();
        return;
      }

      let intro = root.querySelector(".cpb-mobile-intro");

      if (!intro) {
        intro = document.createElement("div");
        intro.className = "cpb-mobile-intro";
      }

      const needsIntroMarkup =
        !intro.querySelector(".cpb-mobile-title") ||
        !intro.querySelector(".cpb-mobile-intro-left > .cpb-mobile-reviews") ||
        !intro.querySelector(".cpb-mobile-intro-left > .cpb-mobile-afterpay");

      if (needsIntroMarkup) {
        if (this.afterpayMovedElement && intro.contains(this.afterpayMovedElement)) {
          document.body.append(this.afterpayMovedElement);
        }

        intro.innerHTML = `
          <div class="cpb-mobile-intro-left">
            <div class="cpb-mobile-title"></div>
            <div class="cpb-mobile-reviews"></div>
            <div class="cpb-mobile-afterpay"></div>
          </div>
        `;
      }

      intro.querySelector(".cpb-mobile-intro-right")?.remove();

      const anchor =
        root.querySelector(".cpb-preview") ||
        root.querySelector(".cpb-product-preview") ||
        root.querySelector(".cpb-product-image") ||
        root.querySelector(".cpb-preview-container") ||
        root.querySelector(".cpb-preview-aside") ||
        root.querySelector(".cpb-layout");

      if (anchor && intro.nextElementSibling !== anchor) {
        anchor.before(intro);
      } else if (!anchor && !intro.parentNode) {
        root.prepend(intro);
      }

      const Product = CPB.getStore().getState().Product || {};
      const titleSource = Array.from(root.querySelectorAll(".cpb-product-title"))
        .find(el => !el.closest(".cpb-mobile-intro"));

      const title = (
        Product.title ||
        Product.name ||
        titleSource?.textContent ||
        ""
      ).replace(/\s+/g, " ").trim();

      intro.querySelector(".cpb-mobile-title").textContent = title;

      const reviewSource = Array.from(root.querySelectorAll(
        ".stamped-product-reviews-badge, .stamped-main-badge, .product-single__review-link"
      )).find(el => !el.closest(".cpb-mobile-intro"));

      const reviewBox = intro.querySelector(".cpb-mobile-reviews");
      reviewBox.innerHTML = "";

      if (reviewSource) {
        reviewBox.append(reviewSource.cloneNode(true));
        reviewBox.style.display = "";

        reviewBox.onclick = () => {
          const createReview = document.querySelector(".stamped-summary-actions-newreview");
          if (!createReview) return;

          const offset = -150;
          const top = createReview.getBoundingClientRect().top + window.scrollY + offset;
          window.scrollTo({ top, behavior: "smooth" });
        };
      } else {
        reviewBox.style.display = "none";
      }

      const afterpayBox = intro.querySelector(".cpb-mobile-afterpay");
      const afterpayElement = this.afterpayMovedElement || this.findAfterpayElement();

      if (afterpayBox && afterpayElement) {
        this.rememberAfterpayPosition(afterpayElement);
        this.afterpayMovedElement = afterpayElement;
        afterpayElement.classList.remove("cpb-desktop-afterpay-widget");
        afterpayElement.classList.add("cpb-mobile-afterpay-widget");

        if (!afterpayBox.contains(afterpayElement)) {
          afterpayBox.append(afterpayElement);
        }

        this.styleAfterpayWidget();
        afterpayBox.style.display = "";
      } else if (afterpayBox) {
        afterpayBox.style.display = "none";
      }
    },

    getMobileCurrentPriceText(root = document.querySelector("#product-builder")) {
      if (!root) return "";

      const priceSource = Array.from(root.querySelectorAll('[data-testid="multycurrency-price"]'))
        .find(el => {
          return (
            !el.closest(".cpb-mobile-intro") &&
            !el.closest(".cpb-mobile-actions-holder") &&
            !el.closest(".cpb-mobile-purchase-footer-price")
          );
        });

      return this.cleanMoneyText(priceSource?.textContent);
    },

    syncMobilePurchaseFooterPrice(actionHolder) {
      if (!actionHolder || window.innerWidth > 768) return null;

      const root = document.querySelector("#product-builder");
      const priceText = this.getMobileCurrentPriceText(root);
      let priceBox = actionHolder.querySelector(".cpb-mobile-purchase-footer-price");

      if (!priceBox) {
        priceBox = document.createElement("div");
        priceBox.className = "cpb-mobile-purchase-footer-price";
      }

      priceBox.textContent = priceText;
      priceBox.style.display = priceText ? "" : "none";

      return priceBox;
    },

    syncMobileFooterAfterpay(actionHolder) {
      if (!actionHolder || window.innerWidth > 768) return null;

      actionHolder.querySelector(".cpb-mobile-footer-afterpay")?.remove();
      actionHolder.querySelectorAll(".cpb-payment-options, .cpb-paypal-pay-in-4-badge").forEach(element => element.remove());

      return null;
    },

    syncDesktopIntro() {
      const root = document.querySelector("#product-builder");
      if (!root) return;

      root.querySelector(".cpb-desktop-intro")?.remove();
    },

    syncDesktopCustomInfo() {
      const root = document.querySelector("#product-builder");
      const customInfo = root?.querySelector(".cpb-custom-info");
      if (!root || !customInfo) return;

      if (window.innerWidth <= 768) {
        if (this.afterpayMovedElement?.closest(".cpb-desktop-custom-afterpay")) {
          this.restoreAfterpayElement();
        }

        customInfo.querySelector(".cpb-desktop-custom-title")?.remove();
        customInfo.querySelector(".cpb-desktop-custom-afterpay")?.remove();
        return;
      }

      const Product = CPB.getStore().getState().Product || {};
      const titleSource = Array.from(root.querySelectorAll(".cpb-product-title"))
        .find(el => !el.closest(".cpb-custom-info") && !el.closest(".cpb-mobile-intro"));
      const title = (
        Product.title ||
        Product.name ||
        titleSource?.textContent ||
        ""
      ).replace(/\s+/g, " ").trim();

      let titleElement = customInfo.querySelector(".cpb-desktop-custom-title");

      if (!titleElement) {
        titleElement = document.createElement("div");
        titleElement.className = "cpb-desktop-custom-title";
        titleElement.style.order = "0";
        customInfo.prepend(titleElement);
      }

      titleElement.textContent = title;
      titleElement.style.display = title ? "" : "none";

      let afterpayBox = customInfo.querySelector(".cpb-desktop-custom-afterpay");

      if (!afterpayBox) {
        afterpayBox = document.createElement("div");
        afterpayBox.className = "cpb-desktop-custom-afterpay";
        customInfo.append(afterpayBox);
      }

      afterpayBox.style.order = "1";

      const afterpayElement = this.afterpayMovedElement || this.findAfterpayElement();

      if (!afterpayElement) {
        afterpayBox.remove();
        return;
      }

      this.rememberAfterpayPosition(afterpayElement);
      this.afterpayMovedElement = afterpayElement;

      afterpayElement.classList.remove("cpb-mobile-afterpay-widget");
      afterpayElement.classList.add("cpb-desktop-afterpay-widget");

      if (!afterpayBox.contains(afterpayElement)) {
        afterpayBox.append(afterpayElement);
      }

      afterpayBox.querySelectorAll(".cpb-payment-options, .cpb-paypal-pay-in-4-badge").forEach(element => element.remove());
      this.styleAfterpayWidget();
      afterpayBox.style.display = "";
    },

    addPriceLabel() {
      if (window.innerWidth > 768) return;

      const Product = CPB.getStore().getState().Product;
      const priceElement = document.querySelector('[data-testid="multycurrency-price"]');
      if (!priceElement) return;

      const currencySymbol = this.cleanMoneyText(priceElement.textContent).replace(/[\d\s,.\u00A0]+/g, "") || "$";
      const formatOptionPrice = value => {
        const withoutPlus = String(value || "")
          .replace(/^\s*\+\s*/, "")
          .trim();

        const cleanedValue = this.cleanMoneyText(withoutPlus).trim();

        if (!cleanedValue) return "";
        if (cleanedValue.includes(currencySymbol)) return cleanedValue;
        if (/[$£€¥]/.test(cleanedValue)) return cleanedValue;

        const numberValue = Number(cleanedValue.replace(/[^\d.]/g, ""));

        if (Number.isFinite(numberValue) && numberValue > 0) {
          return `${currencySymbol}${numberValue.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}`;
        }

        return `${currencySymbol}${cleanedValue}`;
      };

      const optionPriceById = {};

      Product.panels.forEach(panel => {
        panel.categories.forEach(category => {
          category.options.forEach(option => {
            if (option.price) {
              optionPriceById[option.id] = formatOptionPrice(option.price);
            }
          });
        });
      });

      document.querySelectorAll("#product-builder [data-option-id]").forEach(optionElement => {
        const optionId = optionElement.getAttribute("data-option-id");
        if (!optionId || optionPriceById[optionId]) return;

        const nativePriceText = this.findNativeOptionPriceText(optionElement);
        if (nativePriceText) {
          optionPriceById[optionId] = formatOptionPrice(nativePriceText);
        }
      });

      this.removeNativeOptionPriceLabels();

      document.querySelectorAll("#product-builder .cpb-clean-option-price").forEach(label => {
        const optionId =
          label.dataset.optionId ||
          label.closest("[data-option-id]")?.getAttribute("data-option-id");

        if (optionId) label.dataset.optionId = optionId;

        label.textContent = optionPriceById[optionId] || formatOptionPrice(label.textContent);
      });

      Product.panels.forEach(panel => {
        panel.categories.forEach(category => {
          category.options.forEach(option => {
            const displayPrice = optionPriceById[option.id];
            if (!displayPrice) return;

            const optionElement = document.querySelector(
              `[data-option-id="${option.id}"]:not(.cpb-option-custom-price)`
            );
            if (!optionElement) return;

            const existingPriceLabels = Array.from(document.querySelectorAll(
              `.cpb-clean-option-price[data-option-id="${option.id}"]`
            ));

            existingPriceLabels.forEach(label => {
              label.textContent = displayPrice;
            });
            existingPriceLabels.slice(1).forEach(label => label.remove());

            if (existingPriceLabels.length) return;

            const priceLabel = document.createElement("div");

            priceLabel.dataset.optionId = option.id;
            priceLabel.textContent = displayPrice;
            priceLabel.classList.add("cpb-option-custom-price");
            priceLabel.classList.add("cpb-clean-option-price");
            optionElement.after(priceLabel);
          });
        });
      });

      Object.keys(optionPriceById).forEach(optionId => {
        const optionElement = document.querySelector(
          `[data-option-id="${optionId}"]:not(.cpb-option-custom-price)`
        );
        if (!optionElement) return;
        if (document.querySelector(`.cpb-clean-option-price[data-option-id="${optionId}"]`)) return;

        const priceLabel = document.createElement("div");

        priceLabel.dataset.optionId = optionId;
        priceLabel.textContent = optionPriceById[optionId];
        priceLabel.classList.add("cpb-option-custom-price");
        priceLabel.classList.add("cpb-clean-option-price");
        optionElement.after(priceLabel);
      });

      this.preserveMobileScroll(() => {
        this.normalizeMobileOptionPriceLabels();
      });
    },

    syncColourCategoryMarkers(root = document.querySelector("#product-builder")) {
      if (!root) return;

      root.querySelectorAll(".cpb-colour-category").forEach(element => {
        element.classList.remove("cpb-colour-category");
      });
      root.querySelectorAll(".cpb-frame-colour-category").forEach(element => {
        element.classList.remove("cpb-frame-colour-category");
      });
      root.querySelectorAll(".cpb-colour-options-container").forEach(element => {
        element.classList.remove("cpb-colour-options-container");
      });
      root.querySelectorAll(".cpb-frame-colour-options-container").forEach(element => {
        element.classList.remove("cpb-frame-colour-options-container");
      });
      root.querySelectorAll(".cpb-colour-title").forEach(element => {
        element.classList.remove("cpb-colour-title");
      });
      root.querySelectorAll(".cpb-compatible-accessories-category").forEach(element => {
        element.classList.remove("cpb-compatible-accessories-category");
      });
      root.querySelectorAll(".cpb-compatible-accessories-options").forEach(element => {
        element.classList.remove("cpb-compatible-accessories-options");
      });
      root.querySelectorAll(".cpb-compatible-accessories-title").forEach(element => {
        element.classList.remove("cpb-compatible-accessories-title");
      });

      Array.from(root.querySelectorAll(".cpb-category-options-container")).forEach(container => {
        if (!container.querySelector("[data-option-id]")) return;

        const category =
          container.closest("[data-category-id]") ||
          container.closest(".cpb-category") ||
          container.parentElement;
        const colourInfo = this.getMobileColourCategoryInfo(category, container);

        container.classList.toggle("cpb-colour-options-container", colourInfo.isColourCategory);
        container.classList.toggle("cpb-frame-colour-options-container", colourInfo.isFrameColourCategory);
        category?.classList.toggle("cpb-colour-category", colourInfo.isColourCategory);
        category?.classList.toggle("cpb-frame-colour-category", colourInfo.isFrameColourCategory);
        colourInfo.titleElement?.classList.toggle("cpb-colour-title", colourInfo.isColourCategory);

        const titleText = (colourInfo.titleElement?.textContent || "").replace(/\s+/g, " ").trim();
        const isCompatibleAccessories = /\bcompatible\s+accessories\b/i.test(titleText);

        container.classList.toggle("cpb-compatible-accessories-options", isCompatibleAccessories);
        category?.classList.toggle("cpb-compatible-accessories-category", isCompatibleAccessories);
        colourInfo.titleElement?.classList.toggle("cpb-compatible-accessories-title", isCompatibleAccessories);

        if (isCompatibleAccessories) {
          this.syncCompatibleAccessoriesInfo(colourInfo.titleElement);
        }
      });

      Array.from(root.querySelectorAll("[data-category-id], .cpb-category")).forEach(category => {
        if (category.classList.contains("cpb-compatible-accessories-category")) return;

        const titleElement = Array.from(category.children || []).find(element => {
          return Boolean(
            element &&
            !element.querySelector?.("[data-option-id]") &&
            (element.textContent || "").replace(/\s+/g, " ").trim()
          );
        });
        const titleText = (titleElement?.textContent || "").replace(/\s+/g, " ").trim();

        if (!/\bcompatible\s+accessories\b/i.test(titleText)) return;

        category.classList.add("cpb-compatible-accessories-category");
        titleElement?.classList.add("cpb-compatible-accessories-title");
        this.syncCompatibleAccessoriesInfo(titleElement);
        category
          .querySelectorAll(".cpb-category-options-container, .option-type-multiple, .cpb-option-type-multiple")
          .forEach(container => {
            container.classList.add("cpb-compatible-accessories-options");
          });
      });
    },

    getCompatibleAccessoriesInfoText() {
      return "Compatibility depends on your selected frame and configuration. Some listed accessories may not be compatible with every setup.";
    },

    syncCompatibleAccessoriesInfo(titleElement) {
      if (!titleElement || titleElement.querySelector(".cpb-compatible-accessories-info-wrap")) return;

      const infoText = this.getCompatibleAccessoriesInfoText();
      const infoId = `cpb-compatible-accessories-info-${Math.random().toString(36).slice(2, 9)}`;
      const wrapper = document.createElement("span");
      const button = document.createElement("button");
      const tooltip = document.createElement("span");

      wrapper.className = "cpb-compatible-accessories-info-wrap";

      button.type = "button";
      button.className = "cpb-compatible-accessories-info-button";
      button.textContent = "i";
      button.setAttribute("aria-label", infoText);
      button.setAttribute("aria-describedby", infoId);

      tooltip.id = infoId;
      tooltip.className = "cpb-compatible-accessories-info-text";
      tooltip.setAttribute("role", "tooltip");
      tooltip.textContent = infoText;

      button.addEventListener("click", event => {
        event.preventDefault();
        event.stopPropagation();

        const root = titleElement.closest("#product-builder") || document;
        root.querySelectorAll(".cpb-compatible-accessories-info-wrap.is-open").forEach(openTooltip => {
          if (openTooltip !== wrapper) openTooltip.classList.remove("is-open");
        });
        wrapper.classList.toggle("is-open");
      });

      button.addEventListener("blur", () => {
        window.setTimeout(() => wrapper.classList.remove("is-open"), 120);
      });

      wrapper.append(button, tooltip);
      titleElement.appendChild(wrapper);
    },

    normalizeMobileOptionPriceLabels() {
      const root = document.querySelector("#product-builder");
      if (!root) return;
      this.syncColourCategoryMarkers(root);
      if (window.innerWidth > 768) return;

      root.querySelectorAll(".cpb-mobile-colour-category").forEach(element => {
        element.classList.remove("cpb-mobile-colour-category");
      });
      root.querySelectorAll(".cpb-mobile-frame-colour-category").forEach(element => {
        element.classList.remove("cpb-mobile-frame-colour-category");
      });
      root.querySelectorAll(".cpb-mobile-colour-options-container").forEach(element => {
        element.classList.remove("cpb-mobile-colour-options-container");
      });
      root.querySelectorAll(".cpb-mobile-frame-colour-options-container").forEach(element => {
        element.classList.remove("cpb-mobile-frame-colour-options-container");
      });
      root.querySelectorAll(".cpb-mobile-colour-title").forEach(element => {
        element.classList.remove("cpb-mobile-colour-title");
      });

      const getOptionIds = element => {
        const optionIds = new Set();

        if (
          element?.matches?.("[data-option-id]") &&
          !element.classList?.contains("cpb-clean-option-price")
        ) {
          optionIds.add(element.getAttribute("data-option-id"));
        }

        Array.from(element?.querySelectorAll?.("[data-option-id]") || [])
          .filter(child => !child.classList?.contains("cpb-clean-option-price"))
          .forEach(child => {
            optionIds.add(child.getAttribute("data-option-id"));
          });

        return optionIds;
      };

      const getOptionShell = (optionElement, boundary) => {
        const optionId = optionElement.getAttribute("data-option-id");
        let shell = optionElement;
        let node = optionElement;

        while (node.parentElement && node.parentElement !== boundary) {
          const parent = node.parentElement;
          const optionIds = getOptionIds(parent);

          if (
            parent.classList.contains("cpb-mobile-normalized-option-row") ||
            optionIds.size !== 1 ||
            !optionIds.has(optionId)
          ) {
            break;
          }

          shell = parent;
          node = parent;
        }

        return shell;
      };

      const containers = Array.from(root.querySelectorAll(
        ".cpb-mobile-step-content-holder .cpb-category-options-container, .cpb-panels-container .react-tabs__tab-panel--selected .cpb-category-options-container, .cpb-panels-container [role='tabpanel'][aria-hidden='false'] .cpb-category-options-container"
      ));

      containers.forEach(container => {
        const seenOptionRoots = new Set();
        const options = [];

        Array.from(container.querySelectorAll("[data-option-id]"))
          .filter(option => !option.classList.contains("cpb-clean-option-price"))
          .forEach(optionElement => {
            const optionId = optionElement.getAttribute("data-option-id");
            if (!optionId) return;

            const optionContent = getOptionShell(optionElement, container);
            const existingShell = optionContent.classList?.contains("cpb-mobile-option-shell")
              ? optionContent
              : optionContent.closest?.(".cpb-mobile-option-shell");
            const optionRoot =
              existingShell && container.contains(existingShell)
                ? existingShell
                : optionContent;

            if (seenOptionRoots.has(optionRoot)) return;

            seenOptionRoots.add(optionRoot);
            options.push({ optionId, optionContent });
          });

        if (!options.length) return;

        const category =
          container.closest("[data-category-id]") ||
          container.closest(".cpb-category") ||
          container.parentElement;
        const holder = container.closest(".cpb-mobile-step-content-holder");
        const colourInfo = this.getMobileColourCategoryInfo(category, container);
        const isColourCategory = colourInfo.isColourCategory;
        const isFrameColourCategory = colourInfo.isFrameColourCategory;

        let row = Array.from(container.children).find(child => {
          return child.classList?.contains("cpb-mobile-normalized-option-row");
        });

        if (!row) {
          row = document.createElement("div");
          row.className = "cpb-mobile-normalized-option-row";
          container.prepend(row);
        }

        container.classList.add("cpb-mobile-normalized-options-container");
        container.classList.add("cpb-mobile-options-ready");
        category?.classList.add("cpb-mobile-options-ready");
        holder?.classList.add("cpb-mobile-options-ready");
        container.classList.toggle("cpb-mobile-colour-options-container", isColourCategory);
        container.classList.toggle("cpb-mobile-frame-colour-options-container", isFrameColourCategory);
        category?.classList.toggle("cpb-mobile-colour-category", isColourCategory);
        category?.classList.toggle("cpb-mobile-frame-colour-category", isFrameColourCategory);
        colourInfo.titleElement?.classList.toggle("cpb-mobile-colour-title", isColourCategory);

        options.forEach(({ optionId, optionContent }) => {
          let shell = optionContent.classList?.contains("cpb-mobile-option-shell")
            ? optionContent
            : optionContent.parentElement?.classList.contains("cpb-mobile-option-shell")
            ? optionContent.parentElement
            : null;

          if (!shell) {
            shell = document.createElement("div");
            shell.className = "cpb-mobile-option-shell";
            optionContent.before(shell);
            shell.append(optionContent);
          }

          optionContent.classList.remove("cpb-mobile-option-shell");
          shell.classList.add("cpb-mobile-option-shell");

          if (!row.contains(shell)) {
            row.append(shell);
          }

          if (!optionId) return;

          const label = root.querySelector(`.cpb-clean-option-price[data-option-id="${optionId}"]`);

          if (label) {
            shell.append(label);
          }

          shell.classList.toggle("cpb-mobile-color-option-shell", isColourCategory);
          shell.classList.toggle("cpb-mobile-frame-colour-option-shell", isFrameColourCategory);
          this.ensureMobileOptionTileFrame(shell, isFrameColourCategory, isFrameColourCategory);
        });

        Array.from(row.children).forEach(child => {
          if (!child.querySelector?.("[data-option-id]:not(.cpb-clean-option-price)")) {
            child.remove();
          }
        });
      });
    },

    getMobileColourCategoryInfo(category, container) {
      const titleCandidates = [
        container?.previousElementSibling,
        ...Array.from(category?.children || [])
      ].filter(element => {
        return Boolean(
          element &&
          element !== container &&
          !element.classList?.contains("cpb-category-options-container") &&
          !element.classList?.contains("cpb-mobile-normalized-options-container") &&
          !element.classList?.contains("cpb-mobile-normalized-option-row") &&
          !element.querySelector?.("[data-option-id]") &&
          (element.textContent || "").trim()
        );
      });
      const titleElement = titleCandidates[0] || null;
      const titleText = (titleElement?.textContent || "").replace(/\s+/g, " ").trim();
      const isFrameColourCategory = /\b(frame\s+colou?r|range\s+of\s+colou?rs?|select\s+from\s+our\s+range)\b/i.test(titleText);
      const isColourCategory = Boolean(
        isFrameColourCategory ||
        /\b(colou?rs?|frame\s+colou?r)\b/i.test(titleText) ||
        container?.classList?.contains("color") ||
        category?.classList?.contains("color") ||
        container?.querySelector?.(".option-type-color, .cpb-option-type-color, [class*='color']")
      );

      return { isColourCategory, isFrameColourCategory, titleElement };
    },

    ensureMobileOptionTileFrame(shell, forceColor = false, hideColorPrice = false) {
      if (!shell) return;

      const isPriceLabel = element => {
        return Boolean(
          element?.classList?.contains("cpb-clean-option-price") ||
          element?.classList?.contains("cpb-option-custom-price")
        );
      };
      const getOptionIdCount = element => {
        if (!element) return 0;

        const optionIds = new Set();

        if (
          element.matches?.("[data-option-id]") &&
          !element.classList?.contains("cpb-clean-option-price")
        ) {
          optionIds.add(element.getAttribute("data-option-id"));
        }

        Array.from(element.querySelectorAll?.("[data-option-id]") || [])
          .filter(child => !child.classList?.contains("cpb-clean-option-price"))
          .forEach(child => {
            optionIds.add(child.getAttribute("data-option-id"));
          });

        return optionIds.size;
      };
      const isTileCandidate = element => {
        const optionIdCount = getOptionIdCount(element);

        return Boolean(
          element &&
          !isPriceLabel(element) &&
          optionIdCount === 1 &&
          (
            element.matches?.(".option, [data-option-id], .cpb-option") ||
            element.querySelector?.("[data-option-id], .cpb-option, img, picture, canvas, model-viewer")
          )
        );
      };

      const frames = Array.from(shell.querySelectorAll(":scope > .cpb-mobile-option-tile-frame"));
      let frame = frames[0] || null;

      frames.slice(1).forEach(extraFrame => {
        Array.from(extraFrame.childNodes).forEach(child => {
          extraFrame.before(child);
        });
        extraFrame.remove();
      });

      if (frame && getOptionIdCount(frame) > 1) {
        Array.from(frame.childNodes).forEach(child => {
          frame.before(child);
        });
        frame.remove();
        frame = null;
      }

      let tileContent = Array.from(shell.children).find(child => {
        return !child.classList?.contains("cpb-mobile-option-tile-frame") && isTileCandidate(child);
      });

      if (!tileContent && frame) {
        tileContent = Array.from(frame.children).find(isTileCandidate);
      }

      if (!tileContent) return;

      if (!frame) {
        frame = document.createElement("div");
        frame.className = "cpb-mobile-option-tile-frame";
        tileContent.before(frame);
      }

      if (!frame.contains(tileContent)) {
        frame.append(tileContent);
      }

      tileContent.classList.add("cpb-mobile-option-tile-content");

      const optionId =
        tileContent.getAttribute("data-option-id") ||
        tileContent.querySelector("[data-option-id]")?.getAttribute("data-option-id") ||
        shell.querySelector("[data-option-id]:not(.cpb-clean-option-price)")?.getAttribute("data-option-id");

      if (optionId) {
        frame.dataset.optionId = optionId;
      }

      const isColorOption = forceColor || Boolean(
        frame.matches(".option-type-color, .cpb-option-type-color") ||
        frame.querySelector(".option-type-color, .cpb-option-type-color")
      );

      frame.classList.toggle("is-color", isColorOption);
      shell.classList.toggle("cpb-mobile-color-option-shell", isColorOption);
      frame.classList.toggle("is-image", Boolean(frame.querySelector(".cpb-option-type-img, img, picture, canvas, model-viewer")));
      frame.classList.toggle("is-active", Boolean(
        frame.querySelector(".active, .cpb-active") ||
        tileContent.classList.contains("active") ||
        tileContent.classList.contains("cpb-active") ||
        shell.classList.contains("active") ||
        shell.classList.contains("cpb-active")
      ));

      const label = Array.from(shell.children).find(child => {
        return (
          isPriceLabel(child) &&
          (!optionId || child.dataset.optionId === optionId)
        );
      });

      if (label && label.previousElementSibling !== frame) {
        frame.after(label);
      }

      if (hideColorPrice) {
        Array.from(shell.querySelectorAll(".cpb-clean-option-price")).forEach(priceLabel => {
          priceLabel.classList.add("cpb-color-option-price-hidden");
        });
      } else {
        Array.from(shell.querySelectorAll(".cpb-clean-option-price")).forEach(priceLabel => {
          priceLabel.classList.remove("cpb-color-option-price-hidden");
        });
      }
    },

    preserveMobileScroll(callback) {
      if (window.innerWidth > 768) {
        return callback();
      }

      return callback();
    },

    restoreMobileStepScroll(force = false) {
      if (window.innerWidth > 768) return;
      if (!force && Date.now() > this.mobileStepScrollRestoreUntil) return;

      const currentTop = window.scrollY || document.documentElement.scrollTop || 0;

      if (Math.abs(currentTop - this.mobileStepScrollTop) > 1) {
        const scrollTo = this.mobileStepOriginalScrollTo || window.scrollTo;

        this.isRestoringMobileStepScroll = true;

        try {
          scrollTo.call(window, {
            left: window.scrollX || document.documentElement.scrollLeft || 0,
            top: this.mobileStepScrollTop,
            behavior: "auto"
          });
        } finally {
          this.isRestoringMobileStepScroll = false;
        }
      }
    },

    lockMobileStepScroll(duration = 700) {
      if (window.innerWidth > 768) return;

      const now = Date.now();

      if (now > this.mobileStepScrollRestoreUntil) {
        this.mobileStepScrollTop = window.scrollY || document.documentElement.scrollTop || 0;
      }

      this.mobileStepScrollRestoreUntil = Math.max(this.mobileStepScrollRestoreUntil, now + duration);
      this.mobileScrollPauseUntil = Math.max(this.mobileScrollPauseUntil, this.mobileStepScrollRestoreUntil);
      this.patchMobileStepScrollFunctions(duration);

      this.mobileStepScrollRestoreTimers.forEach(timer => clearTimeout(timer));
      this.mobileStepScrollRestoreTimers = [0, 1, 16, 32, 64, 100, 170, 290, 470, 720, duration].map(delay => {
        return setTimeout(() => {
          this.restoreMobileStepScroll(delay === duration);
        }, delay);
      });
    },

    patchMobileStepScrollFunctions(duration = 1100) {
      if (window.innerWidth > 768) return;

      const unpatchDelay = duration + 120;
      const shouldBlockScroll = () => {
        return (
          window.innerWidth <= 768 &&
          !this.isRestoringMobileStepScroll &&
          Date.now() <= this.mobileStepScrollRestoreUntil
        );
      };
      const restoreSoon = () => {
        requestAnimationFrame(() => this.restoreMobileStepScroll(true));
      };

      clearTimeout(this.mobileStepScrollPatchTimer);

      if (!this.mobileStepScrollFunctionsPatched) {
        this.mobileStepScrollFunctionsPatched = true;
        this.mobileStepOriginalScrollTo = window.scrollTo;
        this.mobileStepOriginalScrollBy = window.scrollBy;
        this.mobileStepOriginalScrollIntoView = Element.prototype.scrollIntoView;

        window.scrollTo = (...args) => {
          if (shouldBlockScroll()) {
            restoreSoon();
            return;
          }

          return this.mobileStepOriginalScrollTo.apply(window, args);
        };

        window.scrollBy = (...args) => {
          if (shouldBlockScroll()) {
            restoreSoon();
            return;
          }

          return this.mobileStepOriginalScrollBy.apply(window, args);
        };

        const behavior = this;

        Element.prototype.scrollIntoView = function(...args) {
          if (shouldBlockScroll()) {
            restoreSoon();
            return;
          }

          return behavior.mobileStepOriginalScrollIntoView.apply(this, args);
        };
      }

      this.mobileStepScrollPatchTimer = setTimeout(() => {
        this.unpatchMobileStepScrollFunctions();
      }, unpatchDelay);
    },

    unpatchMobileStepScrollFunctions() {
      if (!this.mobileStepScrollFunctionsPatched) return;

      if (Date.now() <= this.mobileStepScrollRestoreUntil) {
        this.mobileStepScrollPatchTimer = setTimeout(() => {
          this.unpatchMobileStepScrollFunctions();
        }, 120);
        return;
      }

      if (this.mobileStepOriginalScrollTo) {
        window.scrollTo = this.mobileStepOriginalScrollTo;
      }

      if (this.mobileStepOriginalScrollBy) {
        window.scrollBy = this.mobileStepOriginalScrollBy;
      }

      if (this.mobileStepOriginalScrollIntoView) {
        Element.prototype.scrollIntoView = this.mobileStepOriginalScrollIntoView;
      }

      this.mobileStepScrollFunctionsPatched = false;
      this.mobileStepOriginalScrollTo = null;
      this.mobileStepOriginalScrollBy = null;
      this.mobileStepOriginalScrollIntoView = null;
    },

    markMobileScrollActivity(event) {
      if (window.innerWidth > 768) return;

      this.mobileScrollPauseUntil = Date.now() + 300;
      this.queueMobileStaticBuilderLayoutLock();
    },

    isMobileScrollActive() {
      const now = Date.now();
      return window.innerWidth <= 768 && (
        now < this.mobileScrollPauseUntil ||
        now < this.mobileOptionTouchUntil
      );
    },

    bindMobileScrollPause() {
      if (this.mobileScrollPauseBound) return;
      this.mobileScrollPauseBound = true;

      const mark = this.markMobileScrollActivity.bind(this);

      window.addEventListener("touchmove", mark, { passive: true });
      window.addEventListener("wheel", mark, { passive: true });
      window.addEventListener("scroll", mark, { passive: true });
    },

    markMobileOptionTouch(isEnding = false) {
      if (window.innerWidth > 768) return;

      const hold = isEnding ? 100 : 420;
      const until = Date.now() + hold;

      this.mobileOptionTouchUntil = until;
      this.mobileScrollPauseUntil = Math.max(this.mobileScrollPauseUntil, until);
    },

    findNativeOptionPriceText(optionElement) {
      const pricePattern = /(?:\+\s*(?:A\$|AU\$|AUD\s*)?\$?\s*|(?:A\$|AU\$|AUD\s*|\$)\s*)\d[\d,]*(?:\.\d{1,2})?/i;
      const containers = [
        optionElement,
        optionElement.closest(".option"),
        optionElement.parentElement
      ].filter(Boolean);

      for (const container of containers) {
        const candidates = [
          container,
          ...Array.from(container.querySelectorAll("*"))
        ];

        for (const candidate of candidates) {
          if (candidate.classList?.contains("cpb-clean-option-price")) continue;

          const text = (candidate.textContent || "").replace(/\s+/g, " ").trim();
          const match = text.match(pricePattern);

          if (match) return match[0];
        }
      }

      let sibling = optionElement.nextElementSibling;
      let checkedSiblings = 0;

      while (sibling && checkedSiblings < 4) {
        if (!sibling.classList?.contains("cpb-clean-option-price")) {
          const text = (sibling.textContent || "").replace(/\s+/g, " ").trim();
          const match = text.match(pricePattern);

          if (match) return match[0];
        }

        sibling = sibling.nextElementSibling;
        checkedSiblings += 1;
      }

      return "";
    },

    removeNativeOptionPriceLabels() {
      if (window.innerWidth > 768) return;

      const root = document.querySelector("#product-builder");
      if (!root) return;

      const priceTokenPattern = /(?:\+\s*(?:A\$|AU\$|AUD\s*)?\$?\s*|(?:A\$|AU\$|AUD\s*|\$)\s*)\d[\d,]*(?:\.\d{1,2})?/i;
      const priceOnlyPattern = /^\s*(?:\+\s*(?:A\$|AU\$|AUD\s*)?\$?\s*|(?:A\$|AU\$|AUD\s*|\$)\s*)\d[\d,]*(?:\.\d{1,2})?\s*$/i;
      const skipTags = ["SCRIPT", "STYLE", "SVG", "PATH", "INPUT", "SELECT", "TEXTAREA"];

      const isOptionTile = element => {
        return Boolean(
          element?.matches?.("[data-option-id], .option") ||
          element?.querySelector?.("[data-option-id], .cpb-option, img")
        );
      };

      root.querySelectorAll(".cpb-native-option-price-hidden").forEach(element => {
        if (!isOptionTile(element)) return;

        element.classList.remove("cpb-native-option-price-hidden");
        element.style.removeProperty("display");
      });

      const hideElement = element => {
        element.classList.add("cpb-native-option-price-hidden");
        element.style.setProperty("display", "none", "important");
      };

      const removePriceTextNodes = element => {
        Array.from(element.childNodes).forEach(node => {
          if (node.nodeType !== Node.TEXT_NODE) return;

          const nodeText = node.textContent || "";
          if (!priceTokenPattern.test(nodeText)) return;

          const nextText = nodeText
            .replace(priceTokenPattern, "")
            .replace(/\s+/g, " ")
            .trim();

          node.textContent = nextText ? ` ${nextText} ` : "";
        });
      };

      const removeFromElement = element => {
        if (!element || element.classList?.contains("cpb-clean-option-price")) return;
        if (skipTags.includes(element.tagName)) return;
        if (element.closest(".cpb-clean-option-price")) return;

        const text = (element.textContent || "").replace(/\s+/g, " ").trim();

        if (priceOnlyPattern.test(text)) {
          if (isOptionTile(element)) {
            removePriceTextNodes(element);
          } else {
            hideElement(element);
          }
          return;
        }

        removePriceTextNodes(element);
      };

      root.querySelectorAll(
        ".cpb-category-options-container .option, .cpb-category-options-container [data-option-id], .cpb-mobile-step-content-holder .option, .cpb-mobile-step-content-holder [data-option-id]"
      ).forEach(optionContainer => {
        if (optionContainer.classList?.contains("cpb-clean-option-price")) return;

        removeFromElement(optionContainer);
        Array.from(optionContainer.querySelectorAll("*")).forEach(removeFromElement);

        let sibling = optionContainer.nextElementSibling;
        let checkedSiblings = 0;

        while (sibling && checkedSiblings < 4) {
          if (!sibling.classList?.contains("cpb-clean-option-price")) {
            removeFromElement(sibling);
          }

          sibling = sibling.nextElementSibling;
          checkedSiblings += 1;
        }
      });
    },

    cleanStepTitle(text) {
      return (text || "")
        .replace(/\s+/g, " ")
        .replace(/^Step\s*\d+\s*[:.-]?\s*/i, "")
        .trim();
    },

    getStepNumberFromTab(tab) {
      if (!tab) return null;

      const datasetNumber = Number(tab.dataset.stepNumber || tab.dataset.cpbStepNumber);
      if (Number.isInteger(datasetNumber) && datasetNumber > 0) {
        return datasetNumber;
      }

      const text = (tab.textContent || "").replace(/\s+/g, " ").trim();
      const match = text.match(/\bStep\s*(\d+)\b/i);
      const textNumber = Number(match?.[1]);

      return Number.isInteger(textNumber) && textNumber > 0 ? textNumber : null;
    },

    getCpbTabs() {
      const Product = CPB.getStore().getState().Product || {};
      const panelCount = Product.panels?.length || 0;
      const tabs = Array.from(document.querySelectorAll(
        "#product-builder .cpb-panels-tabs .react-tabs__tab-list > li:not(.cpb-mobile-step-content-holder):not(.cpb-mobile-step-content-item)"
      )).filter(tab => this.cleanStepTitle(tab.textContent));

      if (!panelCount || tabs.length <= panelCount) return tabs;

      const visibleTabs = tabs.filter(tab => {
        const rect = tab.getBoundingClientRect();
        return tab.offsetParent !== null && rect.width > 0 && rect.height > 0;
      });

      const numberedTabs = Array.from({ length: panelCount }, (_, index) => {
        return visibleTabs.find(tab => this.getStepNumberFromTab(tab) === index + 1);
      });

      if (numberedTabs.every(Boolean)) {
        return numberedTabs;
      }

      if (visibleTabs.length >= panelCount) {
        return visibleTabs.slice(-panelCount);
      }

      return tabs.slice(-panelCount);
    },

    getClickedStepIndex(tab, tabs) {
      const Product = CPB.getStore().getState().Product || {};
      const panelCount = Product.panels?.length || tabs.length;
      const stepNumber = this.getStepNumberFromTab(tab);

      if (stepNumber && stepNumber <= panelCount) {
        return stepNumber - 1;
      }

      const tabIndex = tabs.indexOf(tab);
      if (tabIndex >= 0) return tabIndex;

      const rawTabs = Array.from(document.querySelectorAll(
        "#product-builder .cpb-panels-tabs .react-tabs__tab-list > li:not(.cpb-mobile-step-content-holder):not(.cpb-mobile-step-content-item)"
      )).filter(item => this.cleanStepTitle(item.textContent));
      const visibleTabs = rawTabs.filter(item => {
        const rect = item.getBoundingClientRect();
        return item.offsetParent !== null && rect.width > 0 && rect.height > 0;
      });
      const visibleIndex = visibleTabs.indexOf(tab);

      if (visibleIndex < 0) return -1;
      if (!panelCount || visibleTabs.length <= panelCount) return visibleIndex;

      return Math.max(0, Math.min(panelCount - 1, visibleIndex - (visibleTabs.length - panelCount)));
    },

    getActiveStepIndex(tabs) {
      const selectedIndex = tabs.findIndex(tab =>
        tab.classList.contains("react-tabs__tab--selected") ||
        tab.getAttribute("aria-selected") === "true"
      );

      if (selectedIndex >= 0) return selectedIndex;

      const activeIndex = tabs.findIndex(tab => tab.classList.contains("cpb-active"));

      return activeIndex >= 0 ? activeIndex : 0;
    },

    getStepTitle(index, tabs) {
      const Product = CPB.getStore().getState().Product;
      const panel = Product.panels[index];

      return this.cleanStepTitle(
        panel?.title ||
        panel?.name ||
        tabs[index]?.textContent ||
        `Step ${index + 1}`
      );
    },

    updateStepUx() {
      const tabs = this.getCpbTabs();
      if (!tabs.length) return;

      tabs.forEach((tab, index) => {
        const title = this.getStepTitle(index, tabs);
        const label = `Step ${index + 1}: ${title}`;

        tab.dataset.stepNumber = index + 1;
        tab.classList.remove(
          "cpb-mobile-step-pending",
          "cpb-mobile-step-open",
          "cpb-mobile-step-collapsed"
        );

        if (tab.textContent.trim() !== label) {
          tab.textContent = label;
        }
      });

      const buttons = Array.from(document.querySelectorAll(
        "#product-builder .cpb-product-actions-container button, #product-builder button"
      ));

      buttons.forEach(button => {
        if (
          button.classList.contains("cpb-next-tab-button") ||
          button.classList.contains("cpb-prev-tab-button") ||
          /^next\b|next tab|^prev|previous/i.test(button.textContent)
        ) {
          button.classList.add("cpb-custom-step-nav-button");
        }
      });
    },

    syncNativeActivePanel() {
      const root = document.querySelector("#product-builder");
      if (!root || window.innerWidth > 768) return;

      const tabs = this.getCpbTabs();
      if (!tabs.length) return;

      const activeIndex = this.getActiveStepIndex(tabs);
      const activeTab = tabs[activeIndex];

      root.querySelectorAll(".cpb-force-visible-panel").forEach(panel => {
        panel.classList.remove("cpb-force-visible-panel");
      });

      if (!activeTab) return;

      const activePanel = this.getActiveCpbPanel(activeTab, activeIndex, root);
      if (!activePanel) return;

      const visiblePanel =
        activePanel.closest(".cpb-panels-container > .react-tabs__tab-panel") ||
        activePanel.closest(".cpb-panels-container > [role='tabpanel']") ||
        activePanel;

      visiblePanel.classList.add("cpb-force-visible-panel");
      [
        "display",
        "height",
        "min-height",
        "max-height",
        "overflow",
        "visibility",
        "opacity"
      ].forEach(property => {
        visiblePanel.style.removeProperty(property);
      });
    },

    clearMobilePanelInlineStyles(element) {
      if (!element) return;

      const properties = [
        "display",
        "height",
        "min-height",
        "max-height",
        "margin",
        "padding",
        "overflow",
        "visibility"
      ];

      const nodes = [
        element,
        ...Array.from(element.querySelectorAll(
          ".react-tabs__tab-panel, [role='tabpanel'], [data-panel-id], .cpb-product-panel, .cpb-category, .cpb-options-container, .cpb-category-options-container"
        ))
      ];

      nodes.forEach(node => {
        properties.forEach(property => {
          node.style.removeProperty(property);
        });
      });
    },

    getActiveCpbPanel(activeTab, activeIndex, root) {
      const hasOptions = panel => {
        return panel && panel.querySelector(
          "[data-category-id], .cpb-category-options-container, .cpb-category"
        );
      };

      const getMoveTarget = panel => {
        if (!panel) return null;

        const tabPanel =
          panel.closest(".react-tabs__tab-panel") ||
          panel.closest("[role='tabpanel']");

        if (tabPanel && !tabPanel.contains(activeTab) && hasOptions(tabPanel)) {
          return tabPanel;
        }

        return hasOptions(panel) ? panel : null;
      };

      const Product = CPB.getStore().getState().Product;
      const panelId = Product?.panels?.[activeIndex]?.id;
      const allPanels = Array.from(root.querySelectorAll(
        ".react-tabs__tab-panel, [role='tabpanel'], [data-panel-id]"
      ));

      if (panelId) {
        const matchingPanel = allPanels.find(panel => {
          if (panel.getAttribute("data-panel-id") == panelId) return true;

          return Array.from(panel.querySelectorAll("[data-panel-id]")).some(child => {
            return child.getAttribute("data-panel-id") == panelId;
          });
        });

        const target = getMoveTarget(matchingPanel);
        if (target) return target;
      }

      const selectedPanel = allPanels.find(panel => {
        return (
          panel.classList.contains("react-tabs__tab-panel--selected") ||
          panel.getAttribute("aria-hidden") === "false"
        ) && hasOptions(panel);
      });

      const selectedTarget = getMoveTarget(selectedPanel);
      if (selectedTarget) return selectedTarget;

      const optionPanel = allPanels.find(panel => hasOptions(panel));
      return getMoveTarget(optionPanel);
    },

    moveActivePanelUnderStep() {
      const root = document.querySelector("#product-builder");
      if (!root) return;

      this.restorePanelsFromMobileHolders(root);
      root.querySelectorAll(
        ".cpb-mobile-step-content-holder:not(.cpb-mobile-actions-holder)"
      ).forEach(holder => holder.remove());
      this.isMobileStepMoving = false;
    },

    trimMobileActionSpace() {
      const root = document.querySelector("#product-builder");
      if (!root) return;

      if (window.innerWidth > 768) {
        const movedActions = this.mobileActionsHolder?.querySelector(".cpb-product-actions");

        if (movedActions && this.actionsOriginalParent) {
          if (
            this.actionsOriginalNextSibling &&
            this.actionsOriginalNextSibling.parentNode === this.actionsOriginalParent
          ) {
            this.actionsOriginalParent.insertBefore(movedActions, this.actionsOriginalNextSibling);
          } else {
            this.actionsOriginalParent.append(movedActions);
          }
        }

        document.body.classList.remove("cpb-mobile-purchase-footer-active");
        this.mobileActionsHolder?.querySelector(".cpb-mobile-purchase-footer-price")?.remove();
        this.mobileActionsHolder?.classList.remove("cpb-mobile-sticky-footer");
        this.mobileActionsHolder?.remove();
        this.mobileActionsHolder = null;
        return;
      }

      root.querySelectorAll(".cpb-mobile-step-content-holder:not(.is-collapsed)").forEach(holder => {
        this.clearMobilePanelInlineStyles(holder);
      });

      const actions =
        root.querySelector(".cpb-product-actions") ||
        this.mobileActionsHolder?.querySelector(".cpb-product-actions") ||
        document.querySelector("body > .cpb-mobile-actions-holder .cpb-product-actions");
      const actionContainer =
        actions?.querySelector(".cpb-product-actions-container") ||
        root.querySelector(".cpb-product-actions-container");
      if (!actions) return;

      if (!this.actionsOriginalParent && !actions.closest(".cpb-mobile-actions-holder")) {
        this.actionsOriginalParent = actions.parentNode;
        this.actionsOriginalNextSibling = actions.nextSibling;
      }

      const existingHolder = actions.closest(".cpb-mobile-step-content-holder");
      const holderHasOptions = Boolean(existingHolder?.querySelector(
        "[data-option-id], .cpb-category-options-container, .cpb-category"
      ));
      let actionHolder =
        actions.closest(".cpb-mobile-actions-holder") ||
        (!holderHasOptions ? existingHolder : null) ||
        this.mobileActionsHolder;

      if (!actionHolder) {
        actionHolder = document.createElement("li");
        actionHolder.setAttribute("role", "presentation");
      }

      this.mobileActionsHolder = actionHolder;
      document.body.classList.add("cpb-mobile-purchase-footer-active");
      actionHolder.classList.add(
        "cpb-mobile-step-content-holder",
        "cpb-mobile-actions-holder",
        "cpb-mobile-sticky-footer"
      );
      actionHolder.classList.remove("is-collapsed");
      actionHolder.style.removeProperty("display");

      document.querySelectorAll("#product-builder .cpb-mobile-actions-holder, body > .cpb-mobile-actions-holder").forEach(holder => {
        if (holder !== actionHolder) holder.remove();
      });

      if (!actionHolder.contains(actions)) {
        actionHolder.append(actions);
      }

      const footerPrice = this.syncMobilePurchaseFooterPrice(actionHolder);
      const footerAfterpay = this.syncMobileFooterAfterpay(actionHolder);

      if (footerPrice && footerPrice.previousElementSibling !== actions) {
        actionHolder.append(footerPrice);
      }

      if (footerAfterpay && footerAfterpay.previousElementSibling !== footerPrice) {
        actionHolder.append(footerAfterpay);
      }

      if (actionHolder.parentNode !== document.body) {
        document.body.append(actionHolder);
      }

      actions?.style.setProperty("margin-top", "0", "important");
      actions?.style.setProperty("padding-top", "0", "important");
      actionContainer?.style.setProperty("margin-top", "0", "important");

      root.querySelectorAll(".cpb-mobile-action-spacer").forEach(element => {
        element.classList.remove("cpb-mobile-action-spacer");
        element.style.removeProperty("display");
      });

      let element = actions?.parentElement;

      while (
        element &&
        element !== root &&
        element !== document.body &&
        !element.classList.contains("cpb-layout") &&
        !element.classList.contains("cpb-mobile-sticky-footer")
      ) {
        element.style.setProperty("height", "auto", "important");
        element.style.setProperty("min-height", "0", "important");
        element.style.setProperty("max-height", "none", "important");
        element.style.setProperty("padding-top", "0", "important");
        element.style.setProperty("padding-bottom", "0", "important");
        element.style.setProperty("margin-top", "0", "important");
        element.style.setProperty("margin-bottom", "0", "important");
        element = element.parentElement;
      }

      actions?.style.setProperty("margin-top", "0", "important");
    },

    getRecommendationAnchor(root) {
      if (window.innerWidth <= 768) {
        return (
          root.querySelector(".cpb-panels-container") ||
          root.querySelector(".cpb-panels-tabs") ||
          root.querySelector(".cpb-layout") ||
          null
        );
      }

      const activeHolder = root.querySelector(".cpb-mobile-step-content-holder:not(.is-collapsed)");
      const activeActions = activeHolder?.querySelector(".cpb-product-actions-container");

      if (activeActions) return activeActions;

      const actionContainers = Array.from(root.querySelectorAll(".cpb-product-actions-container"));
      return (
        actionContainers.find(container => container.offsetParent !== null) ||
        actionContainers[0] ||
        null
      );
    },

    getRecommendationSourceHtml() {
      const source = document.querySelector("#cpb-metafield-box-source");
      const sourceHtml = source?.innerHTML.trim() || "";

      return sourceHtml ? sourceHtml : "";
    },

    getLifestyleGallerySourceHtml() {
      const source = document.querySelector("#cpb-lifestyle-gallery-source");
      const sourceHtml = source?.innerHTML.trim() || "";

      return sourceHtml ? sourceHtml : "";
    },

    getHiddenSourceHtml(selector) {
      const source = document.querySelector(selector);
      const sourceHtml = source?.innerHTML.trim() || "";

      return sourceHtml ? sourceHtml : "";
    },

    fillRecommendationBox(box, sourceHtml) {
      if (box.innerHTML.trim() !== sourceHtml) {
        box.innerHTML = sourceHtml;
      }
    },

    syncMobileProductInfoBox(root, sourceHtml) {
      let accordion = root.querySelector(".cpb-mobile-product-info");

      if (!sourceHtml) {
        accordion?.remove();
        return false;
      }

      if (!accordion) {
        accordion = document.createElement("div");
        accordion.className = "cpb-mobile-product-info";
        accordion.innerHTML = `
          <button class="cpb-mobile-product-info-toggle" type="button" aria-expanded="false">
            <span>Product Information</span>
          </button>
          <div class="cpb-mobile-product-info-body" hidden></div>
        `;

        const toggle = accordion.querySelector(".cpb-mobile-product-info-toggle");
        const body = accordion.querySelector(".cpb-mobile-product-info-body");

        toggle.addEventListener("click", () => {
          const isOpen = accordion.classList.toggle("is-open");

          toggle.setAttribute("aria-expanded", String(isOpen));
          body.hidden = !isOpen;
        });
      }

      const tabList = root.querySelector(".cpb-panels-tabs .react-tabs__tab-list");
      const tabs = root.querySelector(".cpb-panels-tabs");
      const anchor = tabList || tabs || root.querySelector(".cpb-layout");

      if (anchor && accordion.nextElementSibling !== anchor) {
        anchor.before(accordion);
      } else if (!anchor && !accordion.parentNode) {
        root.prepend(accordion);
      }

      const body = accordion.querySelector(".cpb-mobile-product-info-body");
      let box = body.querySelector(".cpb-recommendation-box");

      if (!box) {
        box = root.querySelector(".cpb-recommendation-box");

        if (!box) {
          box = document.createElement("div");
          box.className = "cpb-recommendation-box";
        }

        body.append(box);
      }

      box.style.removeProperty("order");
      this.fillRecommendationBox(box, sourceHtml);

      return true;
    },

    injectDesktopRecommendationBox(priceClone) {
      if (window.innerWidth <= 768 || !priceClone) return false;

      const sourceHtml = this.getRecommendationSourceHtml();
      if (!sourceHtml) return false;

      let box = document.querySelector("#product-builder .cpb-recommendation-box");

      if (!box) {
        box = document.createElement("div");
        box.className = "cpb-recommendation-box";
      }

      box.style.order = "4";
      this.fillRecommendationBox(box, sourceHtml);

      if (priceClone.nextElementSibling !== box) {
        priceClone.after(box);
      }

      return true;
    },

    getBestForSourceHtml() {
      const source = document.querySelector("#cpb-metafield-box-source .recommendation-card");
      return source?.outerHTML.trim() || "";
    },

    syncDesktopBestForBox() {
      const root = document.querySelector("#product-builder");
      if (!root) return;

      let panel = root.querySelector(".cpb-desktop-best-for-panel");

      if (window.innerWidth <= 768) {
        panel?.remove();
        return;
      }

      const sourceHtml = this.getBestForSourceHtml();

      if (!sourceHtml) {
        panel?.remove();
        return;
      }

      const anchor = this.getRecommendationAnchor(root);
      if (!anchor) return;

      if (!panel) {
        panel = document.createElement("section");
        panel.className = "cpb-desktop-best-for-panel";
      }

      if (panel.innerHTML.trim() !== sourceHtml) {
        panel.innerHTML = sourceHtml;
      }

      if (anchor.nextElementSibling !== panel) {
        anchor.after(panel);
      }
    },

    placeDesktopRecommendationBox(root, box) {
      const customInfo = root.querySelector(".cpb-custom-info");
      const price = customInfo?.querySelector(".custom-price");

      if (customInfo) {
        return this.injectDesktopRecommendationBox(price);
      }

      const fallbackAnchor =
        root.querySelector(".cpb-product-builder") ||
        root.querySelector(".cpb-theme-provider") ||
        root.querySelector(".cpb-layout");

      if (!fallbackAnchor) return false;

      box.style.removeProperty("order");

      if (fallbackAnchor.previousElementSibling !== box) {
        fallbackAnchor.before(box);
      }

      return true;
    },

    syncRecommendationBoxes() {
      const root = document.querySelector("#product-builder");
      const existing = root?.querySelector(".cpb-recommendation-box");

      if (!root) return;

      const sourceHtml = this.getRecommendationSourceHtml();

      if (!sourceHtml) {
        existing?.remove();
        root.querySelector(".cpb-mobile-product-info")?.remove();
        return;
      }

      let box = existing;

      if (!box) {
        box = document.createElement("div");
        box.className = "cpb-recommendation-box";
      }

      this.fillRecommendationBox(box, sourceHtml);

      if (window.innerWidth > 768) {
        root.querySelector(".cpb-mobile-product-info")?.remove();
        this.placeDesktopRecommendationBox(root, box);
        return;
      }

      this.syncMobileProductInfoBox(root, sourceHtml);
    },

    getLastPostActionPanel(root) {
      const panels = Array.from(root.querySelectorAll(
        ".cpb-seo-summary-panel, .cpb-feature-cards-panel, .cpb-key-features-panel, .cpb-recommended-products-panel, .cpb-compatible-accessories-panel, .cpb-product-faqs-panel"
      ));

      return panels[panels.length - 1] || null;
    },

    getDesktopPostActionAnchor(root) {
      return (
        root.querySelector(".cpb-layout") ||
        root.querySelector(".cpb-product-builder") ||
        root.querySelector(".cpb-theme-provider")
      );
    },

    syncDesktopOverviewCard(root = document.querySelector("#product-builder")) {
      const existing = root?.querySelector(".cpb-desktop-overview-card");

      if (!root) return;

      if (window.innerWidth <= 768) {
        existing?.remove();
        return;
      }

      const sourceHtml = this.getHiddenSourceHtml("#cpb-seo-summary-source");
      const customInfo = root.querySelector(".cpb-custom-info");

      if (!sourceHtml || !customInfo) {
        existing?.remove();
        return;
      }

      let card = existing;

      if (!card) {
        card = document.createElement("div");
        card.className = "cpb-desktop-overview-card";
      }

      if (card.__cpbSourceHtml !== sourceHtml) {
        card.innerHTML = sourceHtml;
        card.__cpbSourceHtml = sourceHtml;
      }

      const statsBox = customInfo.querySelector(".cpb-recommendation-box");

      if (statsBox && statsBox.nextElementSibling !== card) {
        statsBox.after(card);
      } else if (!statsBox && customInfo.lastElementChild !== card) {
        customInfo.append(card);
      }
    },

    syncPostActionPanels() {
      const root = document.querySelector("#product-builder");
      if (!root) return;

      const isDesktop = window.innerWidth > 768;
      this.syncDesktopOverviewCard(root);

      const panels = [
        {
          selector: "#cpb-seo-summary-source",
          className: "cpb-seo-summary-panel"
        },
        {
          selector: "#cpb-feature-cards-source",
          className: "cpb-feature-cards-panel"
        },
        {
          selector: "#cpb-key-features-source",
          className: "cpb-key-features-panel"
        },
        {
          selector: "#cpb-recommended-products-source",
          className: "cpb-recommended-products-panel"
        },
        {
          selector: "#cpb-compatible-accessories-source",
          className: "cpb-compatible-accessories-panel"
        },
        {
          selector: "#cpb-product-faqs-source",
          className: "cpb-product-faqs-panel"
        }
      ];

      let anchor = isDesktop
        ? this.getDesktopPostActionAnchor(root)
        : this.getRecommendationAnchor(root);

      if (!anchor) {
        anchor = this.getRecommendationAnchor(root);
      }

      if (!anchor) return;

      panels.forEach(panelInfo => {
        const sourceHtml = this.getHiddenSourceHtml(panelInfo.selector);
        let panel = root.querySelector(`.${panelInfo.className}`);

        if (isDesktop && panelInfo.className === "cpb-seo-summary-panel") {
          panel?.remove();
          return;
        }

        if (
          panelInfo.className === "cpb-key-features-panel" &&
          this.getHiddenSourceHtml("#cpb-feature-cards-source")
        ) {
          panel?.remove();
          return;
        }

        if (panelInfo.className === "cpb-recommended-products-panel") {
          const galleryPanel = root.querySelector(".cpb-lifestyle-gallery-panel");
          const gallerySourceHtml = this.getLifestyleGallerySourceHtml();

          if (galleryPanel && gallerySourceHtml) {
            if (anchor.nextElementSibling !== galleryPanel) {
              if (anchor !== galleryPanel) {
                anchor.after(galleryPanel);
              }
            }

            anchor = galleryPanel;
          }
        }

        if (!sourceHtml) {
          panel?.remove();
          return;
        }

        if (!panel) {
          panel = document.createElement("section");
          panel.className = `cpb-post-action-panel ${panelInfo.className}`;
        }

        if (panel.__cpbSourceHtml !== sourceHtml) {
          panel.innerHTML = sourceHtml;
          panel.__cpbSourceHtml = sourceHtml;
        }

        if (anchor.nextElementSibling !== panel) {
          anchor.after(panel);
        }

        anchor = panel;
      });

      this.syncRecommendedProductsSlider();
      this.syncCompatibleAccessoriesSlider();
      this.scheduleDesktopPreviewFollower();
    },

    updateRecommendedProductsSlider(panel) {
      const track = panel?.querySelector(".cpb-recommended-products-track");

      if (!panel || !track || window.innerWidth > 768) {
        panel?.querySelectorAll(".cpb-recommended-products-arrow").forEach(arrow => arrow.remove());
        return;
      }

      const cards = Array.from(track.querySelectorAll(".cpb-recommended-product-card"));
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const canScroll = cards.length > 4 && maxScroll > 3;

      panel.classList.toggle("cpb-recommended-products-has-more", canScroll);

      if (!canScroll) {
        panel.querySelectorAll(".cpb-recommended-products-arrow").forEach(arrow => arrow.remove());
        return;
      }

      const ensureArrow = direction => {
        const className = direction < 0
          ? "cpb-recommended-products-arrow-left"
          : "cpb-recommended-products-arrow-right";

        let arrow = panel.querySelector(`.${className}`);

        if (!arrow) {
          arrow = document.createElement("button");
          arrow.type = "button";
          arrow.className = `cpb-recommended-products-arrow ${className}`;
          arrow.setAttribute("aria-label", direction < 0 ? "Scroll products left" : "Scroll products right");
          arrow.textContent = direction < 0 ? "‹" : "›";

          arrow.addEventListener("click", event => {
            event.preventDefault();
            event.stopPropagation();

            track.scrollBy({
              left: direction * Math.max(120, track.clientWidth * 0.82),
              behavior: "smooth"
            });

            clearTimeout(this.mobileOptionSliderTimers.get(track));
            this.mobileOptionSliderTimers.set(track, setTimeout(() => {
              this.updateRecommendedProductsSlider(panel);
            }, 260));
          });

          panel.append(arrow);
        }

        return arrow;
      };

      const leftArrow = ensureArrow(-1);
      const rightArrow = ensureArrow(1);
      const updateArrowVisibility = () => {
        const currentMaxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

        leftArrow.hidden = track.scrollLeft <= 3;
        rightArrow.hidden = currentMaxScroll <= 3 || track.scrollLeft >= currentMaxScroll - 3;

        panel.style.setProperty(
          "--cpb-recommended-arrow-top",
          `${track.offsetTop + (track.clientHeight / 2)}px`
        );
      };

      if (!track.dataset.cpbRecommendedSliderBound) {
        track.dataset.cpbRecommendedSliderBound = "true";
        track.addEventListener("scroll", updateArrowVisibility, { passive: true });
      }

      requestAnimationFrame(updateArrowVisibility);
      setTimeout(updateArrowVisibility, 180);
    },

    syncRecommendedProductsSlider() {
      const root = document.querySelector("#product-builder");
      if (!root) return;

      const panels = Array.from(root.querySelectorAll(".cpb-recommended-products-panel"));

      if (window.innerWidth > 768) {
        root.querySelectorAll(".cpb-recommended-products-arrow").forEach(arrow => arrow.remove());
        panels.forEach(panel => panel.classList.remove("cpb-recommended-products-has-more"));
        return;
      }

      panels.forEach(panel => this.updateRecommendedProductsSlider(panel));
    },

    normaliseCompatibleAccessoriesSearchText(value) {
      return (value || "")
        .toString()
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
    },

    filterCompatibleAccessories(panel) {
      const input = panel?.querySelector(".cpb-compatible-accessories-search");
      const track = panel?.querySelector(".cpb-compatible-accessories-track");

      if (!panel || !track) return [];

      const query = this.normaliseCompatibleAccessoriesSearchText(input?.value);
      const cards = Array.from(track.querySelectorAll(".cpb-compatible-accessory-card"));
      let emptyState = panel.querySelector(".cpb-compatible-accessories-empty");
      const visibleCards = [];

      cards.forEach(card => {
        const searchText = this.normaliseCompatibleAccessoriesSearchText(card.textContent);
        const isVisible = !query || searchText.includes(query);

        card.classList.toggle("is-hidden", !isVisible);
        card.setAttribute("aria-hidden", isVisible ? "false" : "true");

        if (isVisible) {
          visibleCards.push(card);
        }
      });

      track.classList.toggle("is-filtered", Boolean(query));

      if (!emptyState) {
        emptyState = document.createElement("p");
        emptyState.className = "cpb-compatible-accessories-empty";
        emptyState.textContent = "No matching accessories found.";
        track.after(emptyState);
      }

      emptyState.hidden = visibleCards.length > 0;

      return visibleCards;
    },

    bindCompatibleAccessoriesSearch(panel) {
      const input = panel?.querySelector(".cpb-compatible-accessories-search");
      const track = panel?.querySelector(".cpb-compatible-accessories-track");

      if (!panel || !input || !track) return;

      if (!input.dataset.cpbCompatibleSearchBound) {
        input.dataset.cpbCompatibleSearchBound = "true";
        input.addEventListener("input", () => {
          track.scrollLeft = 0;
          this.filterCompatibleAccessories(panel);
          this.updateCompatibleAccessoriesSlider(panel);
        });
      }

      this.filterCompatibleAccessories(panel);
    },

    updateCompatibleAccessoriesSlider(panel) {
      const track = panel?.querySelector(".cpb-compatible-accessories-track");

      if (!panel || !track) {
        panel?.querySelectorAll(".cpb-compatible-accessories-arrow").forEach(arrow => arrow.remove());
        return;
      }

      this.bindCompatibleAccessoriesSearch(panel);

      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const canScroll = track.querySelectorAll(".cpb-compatible-accessory-card:not(.is-hidden)").length > 4 && maxScroll > 3;

      panel.classList.toggle("cpb-compatible-accessories-has-more", canScroll);

      if (!canScroll) {
        panel.querySelectorAll(".cpb-compatible-accessories-arrow").forEach(arrow => arrow.remove());
        return;
      }

      const ensureArrow = direction => {
        const className = direction < 0
          ? "cpb-compatible-accessories-arrow-left"
          : "cpb-compatible-accessories-arrow-right";

        let arrow = panel.querySelector(`.${className}`);

        if (!arrow) {
          arrow = document.createElement("button");
          arrow.type = "button";
          arrow.className = `cpb-compatible-accessories-arrow ${className}`;
          arrow.setAttribute("aria-label", direction < 0 ? "Scroll compatible accessories left" : "Scroll compatible accessories right");
          arrow.textContent = direction < 0 ? "‹" : "›";

          arrow.addEventListener("click", event => {
            event.preventDefault();
            event.stopPropagation();

            track.scrollBy({
              left: direction * Math.max(160, track.clientWidth * 0.82),
              behavior: "smooth"
            });

            clearTimeout(this.mobileOptionSliderTimers.get(track));
            this.mobileOptionSliderTimers.set(track, setTimeout(() => {
              this.updateCompatibleAccessoriesSlider(panel);
            }, 260));
          });

          panel.append(arrow);
        }

        return arrow;
      };

      const leftArrow = ensureArrow(-1);
      const rightArrow = ensureArrow(1);
      const updateArrowVisibility = () => {
        const currentMaxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

        leftArrow.hidden = track.scrollLeft <= 3;
        rightArrow.hidden = currentMaxScroll <= 3 || track.scrollLeft >= currentMaxScroll - 3;

        panel.style.setProperty(
          "--cpb-compatible-arrow-top",
          `${track.offsetTop + (track.clientHeight / 2)}px`
        );
      };

      if (!track.dataset.cpbCompatibleSliderBound) {
        track.dataset.cpbCompatibleSliderBound = "true";
        track.addEventListener("scroll", updateArrowVisibility, { passive: true });
      }

      requestAnimationFrame(updateArrowVisibility);
      setTimeout(updateArrowVisibility, 180);
    },

    syncCompatibleAccessoriesSlider() {
      const root = document.querySelector("#product-builder");
      if (!root) return;

      root
        .querySelectorAll(".cpb-compatible-accessories-panel")
        .forEach(panel => this.updateCompatibleAccessoriesSlider(panel));
    },

    getDesktopPreviewFollowElement(root) {
      return (
        root?.querySelector(".cpb-preview-sticky") ||
        root?.querySelector(".cpb-preview-container") ||
        root?.querySelector(".cpb-product-preview") ||
        root?.querySelector(".cpb-product-image") ||
        root?.querySelector(".cpb-preview")
      );
    },

    resetDesktopPreviewFollower(root = document.querySelector("#product-builder")) {
      root?.classList.remove("cpb-desktop-preview-follow-active");
      root?.querySelectorAll(".cpb-desktop-preview-following").forEach(element => {
        element.classList.remove("cpb-desktop-preview-following");
        element.style.removeProperty("--cpb-desktop-preview-y");
      });
    },

    syncDesktopPreviewFollower() {
      const root = document.querySelector("#product-builder");
      const followElement = this.getDesktopPreviewFollowElement(root);
      const stopPanel =
        root?.querySelector(".cpb-desktop-best-for-panel") ||
        root?.querySelector(".cpb-feature-cards-panel") ||
        root?.querySelector(".cpb-recommended-products-panel") ||
        root?.querySelector(".cpb-post-action-panel");

      if (window.innerWidth <= 768 || !root || !followElement || !stopPanel) {
        this.resetDesktopPreviewFollower(root);
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const topOffset = 22;
      const releaseGap = 22;
      const visibleRatio = Number.parseFloat(
        window.getComputedStyle(root).getPropertyValue("--cpb-desktop-preview-visible-ratio")
      ) || 0.58;
      const followRect = followElement.getBoundingClientRect();
      const stopRect = stopPanel.getBoundingClientRect();
      const previousY = Number.parseFloat(
        followElement.style.getPropertyValue("--cpb-desktop-preview-y")
      ) || 0;
      const followHeight = followRect.height || 0;
      const naturalFollowTop = followRect.top + scrollTop - previousY;
      const stopTop = stopRect.top + scrollTop;
      const canvasAdjustedHeight = Math.max(320, followHeight * visibleRatio);
      const viewportAdjustedHeight = Math.max(420, window.innerHeight - topOffset - 48);
      const visibleFollowHeight = Math.min(
        followHeight,
        canvasAdjustedHeight,
        viewportAdjustedHeight,
        820
      );
      const maxY = Math.max(0, stopTop - naturalFollowTop - visibleFollowHeight - releaseGap);
      const nextY = Math.max(0, Math.min(scrollTop + topOffset - naturalFollowTop, maxY));

      followElement.classList.add("cpb-desktop-preview-following");
      followElement.style.setProperty("--cpb-desktop-preview-y", `${Math.round(nextY)}px`);
      root.classList.toggle("cpb-desktop-preview-follow-active", nextY > 0);
    },

    scheduleDesktopPreviewFollower() {
      cancelAnimationFrame(this.desktopPreviewFollowRaf);
      this.desktopPreviewFollowRaf = requestAnimationFrame(() => {
        this.syncDesktopPreviewFollower();
      });
    },

    bindDesktopPreviewFollower() {
      if (this.desktopPreviewFollowBound) return;

      this.desktopPreviewFollowBound = true;

      window.addEventListener("scroll", () => {
        this.scheduleDesktopPreviewFollower();
      }, { passive: true });

      window.addEventListener("resize", () => {
        this.scheduleDesktopPreviewFollower();
      });
    },

    syncLifestyleGallery() {
      const root = document.querySelector("#product-builder");
      if (!root) return;

      let panel = root.querySelector(".cpb-lifestyle-gallery-panel");
      const sourceHtml = this.getLifestyleGallerySourceHtml();

      if (!sourceHtml) {
        panel?.remove();
        return;
      }

      if (!panel) {
        panel = document.createElement("section");
        panel.className = "cpb-lifestyle-gallery-panel";
        panel.innerHTML = `
          <h3 class="cpb-lifestyle-gallery-title">Gallery</h3>
          <div class="cpb-lifestyle-gallery-track"></div>
        `;
      }

      const title = panel.querySelector(".cpb-lifestyle-gallery-title");
      if (title && title.textContent.trim() !== "Gallery") {
        title.textContent = "Gallery";
      }

      const track = panel.querySelector(".cpb-lifestyle-gallery-track");

      if (!track.__cpbLifestyleBound) {
        track.__cpbLifestyleBound = true;
        let galleryDrag = null;

        const getPoint = event => {
          const touch = event.touches?.[0] || event.changedTouches?.[0];

          return {
            x: touch ? touch.clientX : event.clientX,
            y: touch ? touch.clientY : event.clientY
          };
        };

        const holdGalleryPosition = () => {
          this.lifestyleGalleryInteractionUntil = Date.now() + 1200;
        };

        const startGalleryDrag = event => {
          const point = getPoint(event);

          galleryDrag = {
            x: point.x,
            y: point.y,
            scrollLeft: track.scrollLeft,
            active: false
          };

          holdGalleryPosition();
        };

        const moveGalleryDrag = event => {
          if (!galleryDrag) return;

          const point = getPoint(event);
          const deltaX = point.x - galleryDrag.x;
          const deltaY = point.y - galleryDrag.y;

          if (!galleryDrag.active) {
            galleryDrag.active = Math.abs(deltaX) > 5 && Math.abs(deltaX) > Math.abs(deltaY);
          }

          if (!galleryDrag.active) return;

          track.scrollLeft = galleryDrag.scrollLeft - deltaX;
          holdGalleryPosition();

          if (event.cancelable) {
            event.preventDefault();
          }

          event.stopPropagation();
        };

        const endGalleryDrag = () => {
          galleryDrag = null;
          holdGalleryPosition();
        };

        track.addEventListener("pointerdown", startGalleryDrag, { passive: true });
        track.addEventListener("pointermove", moveGalleryDrag, { passive: false });
        track.addEventListener("pointerup", endGalleryDrag, { passive: true });
        track.addEventListener("pointercancel", endGalleryDrag, { passive: true });
        track.addEventListener("touchstart", startGalleryDrag, { passive: true });
        track.addEventListener("touchmove", moveGalleryDrag, { passive: false });
        track.addEventListener("touchend", endGalleryDrag, { passive: true });
        track.addEventListener("touchcancel", endGalleryDrag, { passive: true });
        track.addEventListener("wheel", holdGalleryPosition, { passive: true });
        track.addEventListener("scroll", () => {
          this.lifestyleGalleryInteractionUntil = Date.now() + 450;
        }, { passive: true });
      }

      if (
        track.__cpbLifestyleSourceHtml === sourceHtml &&
        Date.now() < this.lifestyleGalleryInteractionUntil
      ) {
        return;
      }

      if (track.__cpbLifestyleSourceHtml !== sourceHtml) {
        const scrollLeft = track.scrollLeft;

        track.innerHTML = sourceHtml;
        track.__cpbLifestyleSourceHtml = sourceHtml;

        requestAnimationFrame(() => {
          track.scrollLeft = scrollLeft;
        });
      }

      Array.from(track.querySelectorAll("img")).forEach((image, index) => {
        image.classList.add("cpb-lifestyle-gallery-image");
        image.draggable = false;
        image.loading = image.loading || "lazy";

        if (!image.alt) {
          image.alt = `Lifestyle image ${index + 1}`;
        }
      });

      this.updateLifestyleGalleryControls(panel, track);

      const recommendedPanel = root.querySelector(".cpb-recommended-products-panel");

      if (recommendedPanel) {
        if (recommendedPanel.previousElementSibling !== panel) {
          recommendedPanel.before(panel);
        }

        return;
      }

      const anchor = this.getLastPostActionPanel(root) || this.getRecommendationAnchor(root);
      if (!anchor) return;

      if (anchor.nextElementSibling !== panel) {
        anchor.after(panel);
      }

      this.scheduleDesktopPreviewFollower();
    },

    updateLifestyleGalleryControls(panel, track) {
      if (!panel || !track) return;

      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const canScroll = maxScroll > 6;

      panel.classList.toggle("cpb-lifestyle-gallery-has-more", canScroll);

      if (!canScroll) {
        panel.querySelectorAll(".cpb-lifestyle-gallery-arrow").forEach(arrow => arrow.remove());
        return;
      }

      const ensureArrow = direction => {
        const className = direction < 0
          ? "cpb-lifestyle-gallery-arrow-left"
          : "cpb-lifestyle-gallery-arrow-right";
        let arrow = panel.querySelector(`.${className}`);

        if (!arrow) {
          arrow = document.createElement("button");
          arrow.type = "button";
          arrow.className = `cpb-lifestyle-gallery-arrow ${className}`;
          arrow.setAttribute("aria-label", direction < 0 ? "Scroll gallery left" : "Scroll gallery right");
          arrow.textContent = direction < 0 ? "‹" : "›";

          arrow.addEventListener("click", event => {
            event.preventDefault();
            event.stopPropagation();

            this.lifestyleGalleryInteractionUntil = Date.now() + 1200;
            track.scrollBy({
              left: direction * Math.max(140, track.clientWidth * 0.72),
              behavior: "smooth"
            });

            setTimeout(() => this.updateLifestyleGalleryControls(panel, track), 320);
          });

          panel.append(arrow);
        }

        return arrow;
      };

      const leftArrow = ensureArrow(-1);
      const rightArrow = ensureArrow(1);
      const updateArrowVisibility = () => {
        const currentMaxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

        leftArrow.hidden = track.scrollLeft <= 4;
        rightArrow.hidden = currentMaxScroll <= 4 || track.scrollLeft >= currentMaxScroll - 4;
        panel.style.setProperty(
          "--cpb-lifestyle-gallery-arrow-top",
          `${track.offsetTop + (track.clientHeight / 2)}px`
        );
      };

      if (!track.__cpbLifestyleArrowBound) {
        track.__cpbLifestyleArrowBound = true;
        track.addEventListener("scroll", updateArrowVisibility, { passive: true });
      }

      requestAnimationFrame(updateArrowVisibility);
      setTimeout(updateArrowVisibility, 180);
    },

    initRecommendationObserver() {
      if (this.recommendationObserver) return;

      this.recommendationObserver = new MutationObserver(mutations => {
        const shouldSync = mutations.some(mutation => {
          const target = mutation.target?.nodeType === Node.ELEMENT_NODE
            ? mutation.target
            : mutation.target?.parentElement;

          if (target?.closest?.(".cpb-lifestyle-gallery-panel")) return false;

          return Boolean(target?.closest?.(
            "#product-builder, #cpb-metafield-box-source, #cpb-seo-summary-source, #cpb-feature-cards-source, #cpb-key-features-source, #cpb-recommended-products-source, #cpb-compatible-accessories-source, #cpb-product-faqs-source, #cpb-lifestyle-gallery-source"
          ));
        });

        if (!shouldSync) return;

        clearTimeout(this.recommendationObserverTimer);
        this.recommendationObserverTimer = setTimeout(() => {
          this.syncRecommendationBoxes();
          this.syncDesktopBestForBox();
          this.syncPostActionPanels();
          this.syncLifestyleGallery();
        }, 220);
      });

      this.recommendationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    },

    updateMobileOptionSliderState(container) {
      const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
      const canScroll = maxScroll > 3;
      const atStart = container.scrollLeft <= 3;
      const atEnd = canScroll && container.scrollLeft >= maxScroll - 3;
      const category =
        container.closest("[data-category-id]") ||
        container.closest(".cpb-category") ||
        container.parentElement;
      const leftArrow = Array.from(category?.children || []).find(child => {
        return child.classList?.contains("cpb-mobile-slider-arrow-left");
      });
      const rightArrow = Array.from(category?.children || []).find(child => {
        return child.classList?.contains("cpb-mobile-slider-arrow-right");
      });

      container.classList.toggle("cpb-slider-at-start", atStart);
      container.classList.toggle("cpb-slider-at-end", atEnd);

      if (leftArrow) leftArrow.hidden = !canScroll || atStart;
      if (rightArrow) rightArrow.hidden = !canScroll || atEnd;
    },

    scrollMobileOptionRow(container, direction) {
      const amount = Math.max(120, container.clientWidth * 0.72);

      container.scrollBy({
        left: direction * amount,
        behavior: "smooth"
      });

      clearTimeout(this.mobileOptionSliderTimers.get(container));
      this.mobileOptionSliderTimers.set(container, setTimeout(() => {
        this.updateMobileOptionSliderState(container);
      }, 260));
    },

    getMobileOptionArrowTop(category, container) {
      const target = container.querySelector(
        ".cpb-option.cpb-option-type-img, .cpb-mobile-option-shell .cpb-option, [data-option-id] .cpb-option, [data-option-id] img, .cpb-mobile-option-shell img, img"
      );

      if (!category || !target) {
        return container.offsetTop + (container.offsetHeight / 2);
      }

      const categoryRect = category.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();

      if (!targetRect.width || !targetRect.height) {
        return container.offsetTop + (container.offsetHeight / 2);
      }

      return (targetRect.top - categoryRect.top) + (targetRect.height / 2);
    },

    ensureMobileOptionArrow(container, direction) {
      const category =
        container.closest("[data-category-id]") ||
        container.closest(".cpb-category") ||
        container.parentElement;

      if (!category) return null;

      category.classList.add("cpb-mobile-slider-wrap");

      const className = direction < 0
        ? "cpb-mobile-slider-arrow-left"
        : "cpb-mobile-slider-arrow-right";

      let arrow = Array.from(category.children).find(child => {
        return child.classList?.contains(className);
      });

      if (!arrow) {
        arrow = document.createElement("button");
        arrow.type = "button";
        arrow.className = `cpb-mobile-slider-arrow ${className}`;
        arrow.setAttribute("aria-label", direction < 0 ? "Scroll options left" : "Scroll options right");
        arrow.textContent = direction < 0 ? "‹" : "›";

        arrow.addEventListener("click", event => {
          event.preventDefault();
          event.stopPropagation();
          this.scrollMobileOptionRow(container, direction);
        });

        category.append(arrow);
      }

      return arrow;
    },

    syncMobileOptionSliders() {
      const root = document.querySelector("#product-builder");
      if (!root) return;

      root.querySelectorAll(".cpb-mobile-slider-row").forEach(container => {
        container.classList.remove("cpb-mobile-slider-row", "cpb-slider-at-start", "cpb-slider-at-end");
        container.style.removeProperty("scroll-snap-type");
        container.style.removeProperty("overflow-x");
      });

      root.querySelectorAll(".cpb-mobile-slider-wrap").forEach(category => {
        category.classList.remove("cpb-mobile-slider-wrap", "cpb-mobile-slider-has-more");
        category.style.removeProperty("--cpb-slider-arrow-top");
      });

      root.querySelectorAll(".cpb-mobile-slider-arrow").forEach(arrow => arrow.remove());
    },

    runFastStepUx() {
      const isMobile = window.innerWidth <= 768;

      this.normalizeCpbProductLayout();
      this.updateStepUx();
      this.moveActivePanelUnderStep();
      this.syncNativeActivePanel();
      this.lockMobileStaticBuilderLayout();

      if (!isMobile) {
        this.trimMobileActionSpace();
        this.normalizeMobileOptionPriceLabels();
        return;
      }

      this.trimMobileActionSpace();
      this.addPriceLabel();
      this.normalizeMobileOptionPriceLabels();
      this.syncMobileOptionSliders();
    },

    runStepUx({ respectScrollPause = true } = {}) {
      if (respectScrollPause && this.isMobileScrollActive()) {
        clearTimeout(this.mobileScrollPauseTimer);
        this.mobileScrollPauseTimer = setTimeout(() => {
          this.runStepUx({ respectScrollPause });
        }, Math.max(80, this.mobileScrollPauseUntil - Date.now() + 80));
        return;
      }

      const isMobile = window.innerWidth <= 768;

      this.normalizeCpbProductLayout();
      this.syncMobileIntro();
      this.updateStepUx();
      this.moveActivePanelUnderStep();
      this.syncNativeActivePanel();
      this.lockMobileStaticBuilderLayout();

      if (isMobile) {
        this.trimMobileActionSpace();
        this.addPriceLabel();
        this.normalizeMobileOptionPriceLabels();
        this.syncMobileOptionSliders();
      } else {
        this.trimMobileActionSpace();
        this.normalizeMobileOptionPriceLabels();
        this.syncDesktopIntro();
        this.syncDesktopCustomInfo();
      }

      this.syncRecommendationBoxes();
      if (isMobile) {
        document.querySelector("#product-builder .cpb-desktop-best-for-panel")?.remove();
      } else {
        this.syncDesktopBestForBox();
      }
      this.syncPostActionPanels();
      this.syncLifestyleGallery();
      this.scheduleDesktopPreviewFollower();
    },

    schedulePostTabUx() {
      if (window.innerWidth > 768) {
        this.scheduleMobileStepUx();
        return;
      }

      cancelAnimationFrame(this.mobileStepRaf);
      this.mobileStepSettleTimers.forEach(timer => clearTimeout(timer));
      this.mobileStepSettleTimers = [];

      this.mobileStepRaf = requestAnimationFrame(() => {
        this.runFastStepUx();
        this.restoreMobileStepScroll();
      });

      this.mobileStepSettleTimers = [
        setTimeout(() => {
          this.runFastStepUx();
          this.restoreMobileStepScroll();
        }, 80),
        setTimeout(() => {
          this.runStepUx({ respectScrollPause: false });
          this.restoreMobileStepScroll();
        }, 220)
      ];
    },

    scheduleMobileStepUx() {
      const run = () => {
        this.runStepUx();
      };

      cancelAnimationFrame(this.mobileStepRaf);
      this.mobileStepSettleTimers.forEach(timer => clearTimeout(timer));
      this.mobileStepSettleTimers = [];

      this.mobileStepRaf = requestAnimationFrame(run);

      this.mobileStepSettleTimers = [220].map(delay => {
        return setTimeout(run, delay);
      });
    },

    restorePanelsFromMobileHolders(root) {
      const panelContainer = root.querySelector(".cpb-panels-container");
      if (!panelContainer) return;

      root.querySelectorAll(
        ".cpb-mobile-step-content-holder:not(.cpb-mobile-actions-holder)"
      ).forEach(holder => {
        Array.from(holder.childNodes).forEach(child => {
          if (child.nodeType !== Node.ELEMENT_NODE) {
            panelContainer.append(child);
            return;
          }

          const position = this.mobilePanelOriginalPositions.get(child);
          const parent = position?.parent?.isConnected ? position.parent : panelContainer;

          if (position?.nextSibling?.parentNode === parent) {
            parent.insertBefore(child, position.nextSibling);
          } else if (position?.previousSibling?.parentNode === parent) {
            position.previousSibling.after(child);
          } else {
            const referenceNode = parent.childNodes[position?.index] || null;
            parent.insertBefore(child, referenceNode);
          }
        });

        holder.remove();
      });
    },

    bindNativeStepTabs() {
      const root = document.querySelector("#product-builder");
      if (!root || root.dataset.nativeStepTabsBound) return;

      root.dataset.nativeStepTabsBound = "true";

      const tabSelector =
        ".cpb-panels-tabs .react-tabs__tab-list > li:not(.cpb-mobile-step-content-holder):not(.cpb-mobile-step-content-item)";

      const isSelected = tab => {
        return (
          tab.classList.contains("react-tabs__tab--selected") ||
          tab.getAttribute("aria-selected") === "true"
        );
      };

      const getEventPoint = event => {
        const touch = event.changedTouches?.[0] || event.touches?.[0];

        return {
          x: touch?.clientX ?? event.clientX ?? 0,
          y: touch?.clientY ?? event.clientY ?? 0
        };
      };

      const startStepGesture = event => {
        const point = getEventPoint(event);

        this.nativeStepPointerStartX = point.x;
        this.nativeStepPointerStartY = point.y;
        this.nativeStepPointerStartAt = Date.now();
        this.nativeStepGestureMoved = false;
      };

      const markStepGestureMovement = event => {
        if (!this.nativeStepPointerStartAt) return false;

        const point = getEventPoint(event);
        const movedX = Math.abs(point.x - this.nativeStepPointerStartX);
        const movedY = Math.abs(point.y - this.nativeStepPointerStartY);
        const didMove = movedX > 10 || movedY > 10;

        if (didMove) {
          this.nativeStepGestureMoved = true;
          this.nativeStepSuppressClickUntil = Date.now() + 500;
        }

        return didMove;
      };

      const isScrollGesture = event => {
        return markStepGestureMovement(event) || this.nativeStepGestureMoved;
      };

      const ensureNativeSelection = tab => {
        if (!tab || window.innerWidth > 768) return;

        const tabIndex = this.getCpbTabs().indexOf(tab);
        if (tabIndex < 0) return;

        this.lockMobileStepScroll(1100);

        setTimeout(() => {
          const tabs = this.getCpbTabs();
          const currentTab = tabs[tabIndex] || tab;

          if (!currentTab?.isConnected || isSelected(currentTab)) {
            this.schedulePostTabUx();
            this.restoreMobileStepScroll(true);
            return;
          }

          const now = Date.now();
          if (now < this.nativeStepSyntheticUntil) return;

          this.nativeStepSyntheticUntil = now + 180;
          this.lockMobileStepScroll(1100);

          this.nativeStepSyntheticClick = true;
          try {
            currentTab.click();
          } finally {
            this.nativeStepSyntheticClick = false;
          }

          this.restoreMobileStepScroll(true);
          requestAnimationFrame(() => this.restoreMobileStepScroll(true));

          setTimeout(() => {
            this.schedulePostTabUx();
            this.restoreMobileStepScroll(true);
          }, 40);
        }, 70);
      };

      root.addEventListener("pointerdown", event => {
        const tab = event.target.closest(tabSelector);
        if (!tab || window.innerWidth > 768) return;

        startStepGesture(event);
      }, { passive: true, capture: true });

      root.addEventListener("pointermove", event => {
        const tab = event.target.closest(tabSelector);
        if (!tab || window.innerWidth > 768) return;

        markStepGestureMovement(event);
      }, { passive: true, capture: true });

      root.addEventListener("touchstart", event => {
        const tab = event.target.closest(tabSelector);
        if (!tab || window.innerWidth > 768) return;

        startStepGesture(event);
      }, { passive: true, capture: true });

      root.addEventListener("touchmove", event => {
        const tab = event.target.closest(tabSelector);
        if (!tab || window.innerWidth > 768) return;

        markStepGestureMovement(event);
      }, { passive: true, capture: true });

      root.addEventListener("click", event => {
        const tab = event.target.closest(tabSelector);
        if (!tab || window.innerWidth > 768) return;

        if (this.nativeStepSyntheticClick) {
          this.lockMobileStepScroll(1100);
          return;
        }

        if (Date.now() < this.nativeStepSuppressClickUntil || this.nativeStepGestureMoved) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        this.lockMobileStepScroll(1100);
        ensureNativeSelection(tab);
      }, { capture: true });

      root.addEventListener("pointerup", event => {
        const tab = event.target.closest(tabSelector);
        if (!tab || window.innerWidth > 768) return;

        if (isScrollGesture(event)) return;

        this.nativeStepPointerAt = Date.now();
      }, { passive: true });

      root.addEventListener("touchend", event => {
        if (Date.now() - this.nativeStepPointerAt < 350) return;

        const tab = event.target.closest(tabSelector);
        if (!tab || window.innerWidth > 768) return;

        if (isScrollGesture(event)) return;

        this.nativeStepPointerAt = Date.now();
      }, { passive: true });
    },

    initMobileStepObserver() {
      const root = document.querySelector("#product-builder");
      if (!root || this.mobileStepObserver) return;

      this.mobileStepObserver = new MutationObserver(mutations => {
        if (this.isMobileStepMoving) return;

        const shouldRefresh = mutations.some(mutation => {
          const target = mutation.target?.nodeType === Node.ELEMENT_NODE
            ? mutation.target
            : mutation.target?.parentElement;

          if (!target) return false;
          if (target.closest?.(
            ".cpb-mobile-slider-arrow, .cpb-clean-option-price, .cpb-mobile-normalized-option-row, .cpb-mobile-option-shell"
          )) {
            return false;
          }

          return (
            mutation.type === "childList" ||
            target.matches?.(".react-tabs__tab, [role='tab'], .react-tabs__tab-panel, [role='tabpanel'], [data-panel-id]") ||
            target.closest?.(".cpb-panels-tabs, .cpb-panels-container")
          );
        });

        if (!shouldRefresh) return;

        clearTimeout(this.mobileStepObserverTimer);
        this.mobileStepObserverTimer = setTimeout(() => {
          this.schedulePostTabUx();
        }, 90);
      });

      this.mobileStepObserver.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "aria-selected", "aria-hidden"]
      });
    },

    async init() {
      if (this.hasInitialized || this.isInitializing) return;
      if (!this.isCpbReady()) return;

      this.isInitializing = true;

      try {
        await this.initApi();

        this.initLogicStorage();
        this.hasInitialized = true;
        this.initStyle();
        this.normalizeCpbProductLayout(true);
        this.addCustomInfo();
        this.syncMobileIntro();
        this.syncDesktopIntro();
        this.syncDesktopCustomInfo();
        this.syncRecommendationBoxes();
        this.syncDesktopBestForBox();
        this.syncPostActionPanels();
        this.syncLifestyleGallery();
        this.bindDesktopPreviewFollower();
        this.scheduleDesktopPreviewFollower();
        this.addPriceLabel();
        this.bindNativeStepTabs();
        this.bindMobileScrollPause();
        this.initMobileStepObserver();
        this.initRecommendationObserver();
        this.scheduleMobileStepUx();

        window.addEventListener("resize", () => {
          this.normalizeCpbProductLayout(true);
          this.scheduleMobileStepUx();
          this.scheduleDesktopPreviewFollower();
        });

        document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", () => {
          setTimeout(this.update.bind(this), 30);
          this.scheduleMobileStepUx();
        });

        document.body.addEventListener("CPB_ON_UPDATE_CURRENT_TAB", () => {
          setTimeout(this.update.bind(this), 30);
          this.schedulePostTabUx();
        });
      } catch (error) {
        this.hasInitialized = false;
        console.warn("CPB custom logic could not initialise yet", error);
      } finally {
        this.isInitializing = false;
      }
    }
  };
})();